/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: unknown; output: unknown; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: unknown; output: unknown; }
  /** The `Upload` scalar type represents a file upload. */
  Upload: { input: unknown; output: unknown; }
};

export type Analysis = {
  __typename?: 'Analysis';
  circumstanceSummary?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  narrative?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['JSON']['output']>;
  otherFactorsConsidered?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

export type AnalysisCreateInput = {
  circumstanceSummary?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  narrative?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['JSON']['input']>;
  otherFactorsConsidered?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ReportRelateToOneForCreateInput>;
};

export type AnalysisOrderByInput = {
  circumstanceSummary?: InputMaybe<OrderDirection>;
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  narrative?: InputMaybe<OrderDirection>;
  otherFactorsConsidered?: InputMaybe<OrderDirection>;
};

export type AnalysisRelateToOneForCreateInput = {
  connect?: InputMaybe<AnalysisWhereUniqueInput>;
  create?: InputMaybe<AnalysisCreateInput>;
};

export type AnalysisRelateToOneForUpdateInput = {
  connect?: InputMaybe<AnalysisWhereUniqueInput>;
  create?: InputMaybe<AnalysisCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AnalysisUpdateArgs = {
  data: AnalysisUpdateInput;
  where: AnalysisWhereUniqueInput;
};

export type AnalysisUpdateInput = {
  circumstanceSummary?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  narrative?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['JSON']['input']>;
  otherFactorsConsidered?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ReportRelateToOneForUpdateInput>;
};

export type AnalysisWhereInput = {
  AND?: InputMaybe<Array<AnalysisWhereInput>>;
  NOT?: InputMaybe<Array<AnalysisWhereInput>>;
  OR?: InputMaybe<Array<AnalysisWhereInput>>;
  circumstanceSummary?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  narrative?: InputMaybe<StringNullableFilter>;
  otherFactorsConsidered?: InputMaybe<StringNullableFilter>;
  report?: InputMaybe<ReportWhereInput>;
};

export type AnalysisWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  report?: InputMaybe<ReportWhereUniqueInput>;
};

export type AuthenticatedItem = User;

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilter>;
};

export type CreateInitialUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<Scalars['DateTime']['input']>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']['input']>>;
};

export type Event = {
  __typename?: 'Event';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type EventCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EventOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type EventUpdateArgs = {
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
};

export type EventUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EventWhereInput = {
  AND?: InputMaybe<Array<EventWhereInput>>;
  NOT?: InputMaybe<Array<EventWhereInput>>;
  OR?: InputMaybe<Array<EventWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type EventWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EvidencePhoto = {
  __typename?: 'EvidencePhoto';
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FieldWork = {
  __typename?: 'FieldWork';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  initialSiteObservations?: Maybe<Scalars['JSON']['output']>;
  preliminaryFireAssessment?: Maybe<Scalars['JSON']['output']>;
  report?: Maybe<Report>;
  siteAccessAndSafety?: Maybe<Scalars['String']['output']>;
};

export type FieldWorkCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  initialSiteObservations?: InputMaybe<Scalars['JSON']['input']>;
  preliminaryFireAssessment?: InputMaybe<Scalars['JSON']['input']>;
  report?: InputMaybe<ReportRelateToOneForCreateInput>;
  siteAccessAndSafety?: InputMaybe<Scalars['String']['input']>;
};

export type FieldWorkOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  siteAccessAndSafety?: InputMaybe<OrderDirection>;
};

export type FieldWorkRelateToOneForCreateInput = {
  connect?: InputMaybe<FieldWorkWhereUniqueInput>;
  create?: InputMaybe<FieldWorkCreateInput>;
};

export type FieldWorkRelateToOneForUpdateInput = {
  connect?: InputMaybe<FieldWorkWhereUniqueInput>;
  create?: InputMaybe<FieldWorkCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldWorkUpdateArgs = {
  data: FieldWorkUpdateInput;
  where: FieldWorkWhereUniqueInput;
};

export type FieldWorkUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  initialSiteObservations?: InputMaybe<Scalars['JSON']['input']>;
  preliminaryFireAssessment?: InputMaybe<Scalars['JSON']['input']>;
  report?: InputMaybe<ReportRelateToOneForUpdateInput>;
  siteAccessAndSafety?: InputMaybe<Scalars['String']['input']>;
};

export type FieldWorkWhereInput = {
  AND?: InputMaybe<Array<FieldWorkWhereInput>>;
  NOT?: InputMaybe<Array<FieldWorkWhereInput>>;
  OR?: InputMaybe<Array<FieldWorkWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  report?: InputMaybe<ReportWhereInput>;
  siteAccessAndSafety?: InputMaybe<StringNullableFilter>;
};

export type FieldWorkWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  report?: InputMaybe<ReportWhereUniqueInput>;
};

export type FireAssessmentCategory = {
  __typename?: 'FireAssessmentCategory';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type FireAssessmentCategoryCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FireAssessmentCategoryOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type FireAssessmentCategoryUpdateArgs = {
  data: FireAssessmentCategoryUpdateInput;
  where: FireAssessmentCategoryWhereUniqueInput;
};

export type FireAssessmentCategoryUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FireAssessmentCategoryWhereInput = {
  AND?: InputMaybe<Array<FireAssessmentCategoryWhereInput>>;
  NOT?: InputMaybe<Array<FireAssessmentCategoryWhereInput>>;
  OR?: InputMaybe<Array<FireAssessmentCategoryWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type FireAssessmentCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GeneratedNarrative = {
  __typename?: 'GeneratedNarrative';
  content: Scalars['String']['output'];
};

export type GeneratedReportPdf = {
  __typename?: 'GeneratedReportPdf';
  base64: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

export type GeneratedSummary = {
  __typename?: 'GeneratedSummary';
  content: Scalars['String']['output'];
  field: Scalars['String']['output'];
};

export type IdFilter = {
  equals?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<Scalars['ID']['input']>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilter>;
  notIn?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type KeystoneAdminMeta = {
  __typename?: 'KeystoneAdminMeta';
  list?: Maybe<KeystoneAdminUiListMeta>;
  lists: Array<KeystoneAdminUiListMeta>;
};


export type KeystoneAdminMetaListArgs = {
  key: Scalars['String']['input'];
};

export type KeystoneAdminUiFieldGroupMeta = {
  __typename?: 'KeystoneAdminUIFieldGroupMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  label: Scalars['String']['output'];
};

export type KeystoneAdminUiFieldMeta = {
  __typename?: 'KeystoneAdminUIFieldMeta';
  createView: KeystoneAdminUiFieldMetaCreateView;
  customViewsIndex?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fieldMeta?: Maybe<Scalars['JSON']['output']>;
  isFilterable: Scalars['Boolean']['output'];
  isNonNull?: Maybe<Array<KeystoneAdminUiFieldMetaIsNonNull>>;
  isOrderable: Scalars['Boolean']['output'];
  itemView?: Maybe<KeystoneAdminUiFieldMetaItemView>;
  label: Scalars['String']['output'];
  listView: KeystoneAdminUiFieldMetaListView;
  path: Scalars['String']['output'];
  search?: Maybe<QueryMode>;
  viewsIndex: Scalars['Int']['output'];
};


export type KeystoneAdminUiFieldMetaItemViewArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type KeystoneAdminUiFieldMetaCreateView = {
  __typename?: 'KeystoneAdminUIFieldMetaCreateView';
  fieldMode: KeystoneAdminUiFieldMetaCreateViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaCreateViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden'
}

export enum KeystoneAdminUiFieldMetaIsNonNull {
  Create = 'create',
  Read = 'read',
  Update = 'update'
}

export type KeystoneAdminUiFieldMetaItemView = {
  __typename?: 'KeystoneAdminUIFieldMetaItemView';
  fieldMode?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldMode>;
  fieldPosition?: Maybe<KeystoneAdminUiFieldMetaItemViewFieldPosition>;
};

export enum KeystoneAdminUiFieldMetaItemViewFieldMode {
  Edit = 'edit',
  Hidden = 'hidden',
  Read = 'read'
}

export enum KeystoneAdminUiFieldMetaItemViewFieldPosition {
  Form = 'form',
  Sidebar = 'sidebar'
}

export type KeystoneAdminUiFieldMetaListView = {
  __typename?: 'KeystoneAdminUIFieldMetaListView';
  fieldMode: KeystoneAdminUiFieldMetaListViewFieldMode;
};

export enum KeystoneAdminUiFieldMetaListViewFieldMode {
  Hidden = 'hidden',
  Read = 'read'
}

export type KeystoneAdminUiGraphQl = {
  __typename?: 'KeystoneAdminUIGraphQL';
  names: KeystoneAdminUiGraphQlNames;
};

export type KeystoneAdminUiGraphQlNames = {
  __typename?: 'KeystoneAdminUIGraphQLNames';
  createInputName: Scalars['String']['output'];
  createManyMutationName: Scalars['String']['output'];
  createMutationName: Scalars['String']['output'];
  deleteManyMutationName: Scalars['String']['output'];
  deleteMutationName: Scalars['String']['output'];
  itemQueryName: Scalars['String']['output'];
  listOrderName: Scalars['String']['output'];
  listQueryCountName: Scalars['String']['output'];
  listQueryName: Scalars['String']['output'];
  outputTypeName: Scalars['String']['output'];
  relateToManyForCreateInputName: Scalars['String']['output'];
  relateToManyForUpdateInputName: Scalars['String']['output'];
  relateToOneForCreateInputName: Scalars['String']['output'];
  relateToOneForUpdateInputName: Scalars['String']['output'];
  updateInputName: Scalars['String']['output'];
  updateManyInputName: Scalars['String']['output'];
  updateManyMutationName: Scalars['String']['output'];
  updateMutationName: Scalars['String']['output'];
  whereInputName: Scalars['String']['output'];
  whereUniqueInputName: Scalars['String']['output'];
};

export type KeystoneAdminUiListMeta = {
  __typename?: 'KeystoneAdminUIListMeta';
  description?: Maybe<Scalars['String']['output']>;
  fields: Array<KeystoneAdminUiFieldMeta>;
  graphql: KeystoneAdminUiGraphQl;
  groups: Array<KeystoneAdminUiFieldGroupMeta>;
  hideCreate: Scalars['Boolean']['output'];
  hideDelete: Scalars['Boolean']['output'];
  initialColumns: Array<Scalars['String']['output']>;
  initialSearchFields: Array<Scalars['String']['output']>;
  initialSort?: Maybe<KeystoneAdminUiSort>;
  isHidden: Scalars['Boolean']['output'];
  isSingleton: Scalars['Boolean']['output'];
  itemQueryName: Scalars['String']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  labelField: Scalars['String']['output'];
  listQueryName: Scalars['String']['output'];
  pageSize: Scalars['Int']['output'];
  path: Scalars['String']['output'];
  plural: Scalars['String']['output'];
  singular: Scalars['String']['output'];
};

export type KeystoneAdminUiSort = {
  __typename?: 'KeystoneAdminUISort';
  direction: KeystoneAdminUiSortDirection;
  field: Scalars['String']['output'];
};

export enum KeystoneAdminUiSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type KeystoneMeta = {
  __typename?: 'KeystoneMeta';
  adminMeta: KeystoneAdminMeta;
};

export enum MagicLinkRedemptionErrorCode {
  Failure = 'FAILURE',
  TokenExpired = 'TOKEN_EXPIRED',
  TokenRedeemed = 'TOKEN_REDEEMED'
}

export type Mutation = {
  __typename?: 'Mutation';
  addSettingOption: Array<SettingOption>;
  authenticateUserWithPassword?: Maybe<UserAuthenticationWithPasswordResult>;
  buildReportConclusions: GeneratedSummary;
  createAnalyses?: Maybe<Array<Maybe<Analysis>>>;
  createAnalysis?: Maybe<Analysis>;
  createEvent?: Maybe<Event>;
  createEvents?: Maybe<Array<Maybe<Event>>>;
  createFieldWork?: Maybe<FieldWork>;
  createFieldWorks?: Maybe<Array<Maybe<FieldWork>>>;
  createFireAssessmentCategories?: Maybe<Array<Maybe<FireAssessmentCategory>>>;
  createFireAssessmentCategory?: Maybe<FireAssessmentCategory>;
  createInitialUser: UserAuthenticationWithPasswordSuccess;
  createObservation?: Maybe<Observation>;
  createObservations?: Maybe<Array<Maybe<Observation>>>;
  createPlaceholder?: Maybe<Placeholder>;
  createPlaceholders?: Maybe<Array<Maybe<Placeholder>>>;
  createPropertyInformation?: Maybe<PropertyInformation>;
  createPropertyInformations?: Maybe<Array<Maybe<PropertyInformation>>>;
  createRelationship?: Maybe<Relationship>;
  createRelationships?: Maybe<Array<Maybe<Relationship>>>;
  createReport?: Maybe<Report>;
  createReportReference?: Maybe<ReportReference>;
  createReportReferences?: Maybe<Array<Maybe<ReportReference>>>;
  createReportReview?: Maybe<ReportReview>;
  createReportReviews?: Maybe<Array<Maybe<ReportReview>>>;
  createReportStage?: Maybe<ReportStage>;
  createReportStages?: Maybe<Array<Maybe<ReportStage>>>;
  createReportStatus?: Maybe<ReportStatus>;
  createReportStatuses?: Maybe<Array<Maybe<ReportStatus>>>;
  createReportSummaries?: Maybe<Array<Maybe<ReportSummary>>>;
  createReportSummary?: Maybe<ReportSummary>;
  createReportType?: Maybe<ReportType>;
  createReportTypes?: Maybe<Array<Maybe<ReportType>>>;
  createReports?: Maybe<Array<Maybe<Report>>>;
  createSetting?: Maybe<Setting>;
  createSettings?: Maybe<Array<Maybe<Setting>>>;
  createUser?: Maybe<User>;
  createUsers?: Maybe<Array<Maybe<User>>>;
  createWitnessInterview?: Maybe<WitnessInterview>;
  createWitnessInterviews?: Maybe<Array<Maybe<WitnessInterview>>>;
  deleteAnalyses?: Maybe<Array<Maybe<Analysis>>>;
  deleteAnalysis?: Maybe<Analysis>;
  deleteEvent?: Maybe<Event>;
  deleteEvents?: Maybe<Array<Maybe<Event>>>;
  deleteFieldWork?: Maybe<FieldWork>;
  deleteFieldWorks?: Maybe<Array<Maybe<FieldWork>>>;
  deleteFireAssessmentCategories?: Maybe<Array<Maybe<FireAssessmentCategory>>>;
  deleteFireAssessmentCategory?: Maybe<FireAssessmentCategory>;
  deleteObservation?: Maybe<Observation>;
  deleteObservations?: Maybe<Array<Maybe<Observation>>>;
  deletePlaceholder?: Maybe<Placeholder>;
  deletePlaceholders?: Maybe<Array<Maybe<Placeholder>>>;
  deletePropertyInformation?: Maybe<PropertyInformation>;
  deletePropertyInformations?: Maybe<Array<Maybe<PropertyInformation>>>;
  deleteRelationship?: Maybe<Relationship>;
  deleteRelationships?: Maybe<Array<Maybe<Relationship>>>;
  deleteReport?: Maybe<Report>;
  deleteReportReference?: Maybe<ReportReference>;
  deleteReportReferences?: Maybe<Array<Maybe<ReportReference>>>;
  deleteReportReview?: Maybe<ReportReview>;
  deleteReportReviews?: Maybe<Array<Maybe<ReportReview>>>;
  deleteReportStage?: Maybe<ReportStage>;
  deleteReportStages?: Maybe<Array<Maybe<ReportStage>>>;
  deleteReportStatus?: Maybe<ReportStatus>;
  deleteReportStatuses?: Maybe<Array<Maybe<ReportStatus>>>;
  deleteReportSummaries?: Maybe<Array<Maybe<ReportSummary>>>;
  deleteReportSummary?: Maybe<ReportSummary>;
  deleteReportType?: Maybe<ReportType>;
  deleteReportTypes?: Maybe<Array<Maybe<ReportType>>>;
  deleteReports?: Maybe<Array<Maybe<Report>>>;
  deleteSetting?: Maybe<Setting>;
  deleteSettings?: Maybe<Array<Maybe<Setting>>>;
  deleteUser?: Maybe<User>;
  deleteUsers?: Maybe<Array<Maybe<User>>>;
  deleteWitnessInterview?: Maybe<WitnessInterview>;
  deleteWitnessInterviews?: Maybe<Array<Maybe<WitnessInterview>>>;
  endSession: Scalars['Boolean']['output'];
  generateAnalysisNarrative: GeneratedNarrative;
  generateReportPdf: GeneratedReportPdf;
  generateReportSummary: GeneratedSummary;
  markReportComplete?: Maybe<ReportStageView>;
  markReportReadyForReview?: Maybe<ReportReadyForReviewView>;
  notifyNewReviewers: ReviewerNotification;
  redeemUserMagicAuthToken: RedeemUserMagicAuthTokenResult;
  sendReportPdf: SendReportPdfResult;
  sendUserMagicAuthLink: Scalars['Boolean']['output'];
  updateAnalyses?: Maybe<Array<Maybe<Analysis>>>;
  updateAnalysis?: Maybe<Analysis>;
  updateEvent?: Maybe<Event>;
  updateEvents?: Maybe<Array<Maybe<Event>>>;
  updateFieldWork?: Maybe<FieldWork>;
  updateFieldWorks?: Maybe<Array<Maybe<FieldWork>>>;
  updateFireAssessmentCategories?: Maybe<Array<Maybe<FireAssessmentCategory>>>;
  updateFireAssessmentCategory?: Maybe<FireAssessmentCategory>;
  updateObservation?: Maybe<Observation>;
  updateObservations?: Maybe<Array<Maybe<Observation>>>;
  updatePlaceholder?: Maybe<Placeholder>;
  updatePlaceholders?: Maybe<Array<Maybe<Placeholder>>>;
  updatePropertyInformation?: Maybe<PropertyInformation>;
  updatePropertyInformations?: Maybe<Array<Maybe<PropertyInformation>>>;
  updateRelationship?: Maybe<Relationship>;
  updateRelationships?: Maybe<Array<Maybe<Relationship>>>;
  updateReport?: Maybe<Report>;
  updateReportReference?: Maybe<ReportReference>;
  updateReportReferences?: Maybe<Array<Maybe<ReportReference>>>;
  updateReportReview?: Maybe<ReportReview>;
  updateReportReviews?: Maybe<Array<Maybe<ReportReview>>>;
  updateReportStage?: Maybe<ReportStage>;
  updateReportStages?: Maybe<Array<Maybe<ReportStage>>>;
  updateReportStatus?: Maybe<ReportStatus>;
  updateReportStatuses?: Maybe<Array<Maybe<ReportStatus>>>;
  updateReportSummaries?: Maybe<Array<Maybe<ReportSummary>>>;
  updateReportSummary?: Maybe<ReportSummary>;
  updateReportType?: Maybe<ReportType>;
  updateReportTypes?: Maybe<Array<Maybe<ReportType>>>;
  updateReports?: Maybe<Array<Maybe<Report>>>;
  updateSetting?: Maybe<Setting>;
  updateSettings?: Maybe<Array<Maybe<Setting>>>;
  updateUser?: Maybe<User>;
  updateUsers?: Maybe<Array<Maybe<User>>>;
  updateWitnessInterview?: Maybe<WitnessInterview>;
  updateWitnessInterviews?: Maybe<Array<Maybe<WitnessInterview>>>;
  uploadReportPhoto: EvidencePhoto;
};


export type MutationAddSettingOptionArgs = {
  field: SettingOptionField;
  value: Scalars['String']['input'];
};


export type MutationAuthenticateUserWithPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationBuildReportConclusionsArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationCreateAnalysesArgs = {
  data: Array<AnalysisCreateInput>;
};


export type MutationCreateAnalysisArgs = {
  data: AnalysisCreateInput;
};


export type MutationCreateEventArgs = {
  data: EventCreateInput;
};


export type MutationCreateEventsArgs = {
  data: Array<EventCreateInput>;
};


export type MutationCreateFieldWorkArgs = {
  data: FieldWorkCreateInput;
};


export type MutationCreateFieldWorksArgs = {
  data: Array<FieldWorkCreateInput>;
};


export type MutationCreateFireAssessmentCategoriesArgs = {
  data: Array<FireAssessmentCategoryCreateInput>;
};


export type MutationCreateFireAssessmentCategoryArgs = {
  data: FireAssessmentCategoryCreateInput;
};


export type MutationCreateInitialUserArgs = {
  data: CreateInitialUserInput;
};


export type MutationCreateObservationArgs = {
  data: ObservationCreateInput;
};


export type MutationCreateObservationsArgs = {
  data: Array<ObservationCreateInput>;
};


export type MutationCreatePlaceholderArgs = {
  data: PlaceholderCreateInput;
};


export type MutationCreatePlaceholdersArgs = {
  data: Array<PlaceholderCreateInput>;
};


export type MutationCreatePropertyInformationArgs = {
  data: PropertyInformationCreateInput;
};


export type MutationCreatePropertyInformationsArgs = {
  data: Array<PropertyInformationCreateInput>;
};


export type MutationCreateRelationshipArgs = {
  data: RelationshipCreateInput;
};


export type MutationCreateRelationshipsArgs = {
  data: Array<RelationshipCreateInput>;
};


export type MutationCreateReportArgs = {
  data: ReportCreateInput;
};


export type MutationCreateReportReferenceArgs = {
  data: ReportReferenceCreateInput;
};


export type MutationCreateReportReferencesArgs = {
  data: Array<ReportReferenceCreateInput>;
};


export type MutationCreateReportReviewArgs = {
  data: ReportReviewCreateInput;
};


export type MutationCreateReportReviewsArgs = {
  data: Array<ReportReviewCreateInput>;
};


export type MutationCreateReportStageArgs = {
  data: ReportStageCreateInput;
};


export type MutationCreateReportStagesArgs = {
  data: Array<ReportStageCreateInput>;
};


export type MutationCreateReportStatusArgs = {
  data: ReportStatusCreateInput;
};


export type MutationCreateReportStatusesArgs = {
  data: Array<ReportStatusCreateInput>;
};


export type MutationCreateReportSummariesArgs = {
  data: Array<ReportSummaryCreateInput>;
};


export type MutationCreateReportSummaryArgs = {
  data: ReportSummaryCreateInput;
};


export type MutationCreateReportTypeArgs = {
  data: ReportTypeCreateInput;
};


export type MutationCreateReportTypesArgs = {
  data: Array<ReportTypeCreateInput>;
};


export type MutationCreateReportsArgs = {
  data: Array<ReportCreateInput>;
};


export type MutationCreateSettingArgs = {
  data: SettingCreateInput;
};


export type MutationCreateSettingsArgs = {
  data: Array<SettingCreateInput>;
};


export type MutationCreateUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateUsersArgs = {
  data: Array<UserCreateInput>;
};


export type MutationCreateWitnessInterviewArgs = {
  data: WitnessInterviewCreateInput;
};


export type MutationCreateWitnessInterviewsArgs = {
  data: Array<WitnessInterviewCreateInput>;
};


export type MutationDeleteAnalysesArgs = {
  where: Array<AnalysisWhereUniqueInput>;
};


export type MutationDeleteAnalysisArgs = {
  where: AnalysisWhereUniqueInput;
};


export type MutationDeleteEventArgs = {
  where: EventWhereUniqueInput;
};


export type MutationDeleteEventsArgs = {
  where: Array<EventWhereUniqueInput>;
};


export type MutationDeleteFieldWorkArgs = {
  where: FieldWorkWhereUniqueInput;
};


export type MutationDeleteFieldWorksArgs = {
  where: Array<FieldWorkWhereUniqueInput>;
};


export type MutationDeleteFireAssessmentCategoriesArgs = {
  where: Array<FireAssessmentCategoryWhereUniqueInput>;
};


export type MutationDeleteFireAssessmentCategoryArgs = {
  where: FireAssessmentCategoryWhereUniqueInput;
};


export type MutationDeleteObservationArgs = {
  where: ObservationWhereUniqueInput;
};


export type MutationDeleteObservationsArgs = {
  where: Array<ObservationWhereUniqueInput>;
};


export type MutationDeletePlaceholderArgs = {
  where: PlaceholderWhereUniqueInput;
};


export type MutationDeletePlaceholdersArgs = {
  where: Array<PlaceholderWhereUniqueInput>;
};


export type MutationDeletePropertyInformationArgs = {
  where: PropertyInformationWhereUniqueInput;
};


export type MutationDeletePropertyInformationsArgs = {
  where: Array<PropertyInformationWhereUniqueInput>;
};


export type MutationDeleteRelationshipArgs = {
  where: RelationshipWhereUniqueInput;
};


export type MutationDeleteRelationshipsArgs = {
  where: Array<RelationshipWhereUniqueInput>;
};


export type MutationDeleteReportArgs = {
  where: ReportWhereUniqueInput;
};


export type MutationDeleteReportReferenceArgs = {
  where: ReportReferenceWhereUniqueInput;
};


export type MutationDeleteReportReferencesArgs = {
  where: Array<ReportReferenceWhereUniqueInput>;
};


export type MutationDeleteReportReviewArgs = {
  where: ReportReviewWhereUniqueInput;
};


export type MutationDeleteReportReviewsArgs = {
  where: Array<ReportReviewWhereUniqueInput>;
};


export type MutationDeleteReportStageArgs = {
  where: ReportStageWhereUniqueInput;
};


export type MutationDeleteReportStagesArgs = {
  where: Array<ReportStageWhereUniqueInput>;
};


export type MutationDeleteReportStatusArgs = {
  where: ReportStatusWhereUniqueInput;
};


export type MutationDeleteReportStatusesArgs = {
  where: Array<ReportStatusWhereUniqueInput>;
};


export type MutationDeleteReportSummariesArgs = {
  where: Array<ReportSummaryWhereUniqueInput>;
};


export type MutationDeleteReportSummaryArgs = {
  where: ReportSummaryWhereUniqueInput;
};


export type MutationDeleteReportTypeArgs = {
  where: ReportTypeWhereUniqueInput;
};


export type MutationDeleteReportTypesArgs = {
  where: Array<ReportTypeWhereUniqueInput>;
};


export type MutationDeleteReportsArgs = {
  where: Array<ReportWhereUniqueInput>;
};


export type MutationDeleteSettingArgs = {
  where?: SettingWhereUniqueInput;
};


export type MutationDeleteSettingsArgs = {
  where: Array<SettingWhereUniqueInput>;
};


export type MutationDeleteUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteUsersArgs = {
  where: Array<UserWhereUniqueInput>;
};


export type MutationDeleteWitnessInterviewArgs = {
  where: WitnessInterviewWhereUniqueInput;
};


export type MutationDeleteWitnessInterviewsArgs = {
  where: Array<WitnessInterviewWhereUniqueInput>;
};


export type MutationGenerateAnalysisNarrativeArgs = {
  circumstanceSummary?: InputMaybe<Scalars['String']['input']>;
  maxWords?: InputMaybe<Scalars['Int']['input']>;
  observationData?: InputMaybe<Scalars['String']['input']>;
  reportId: Scalars['ID']['input'];
};


export type MutationGenerateReportPdfArgs = {
  reportId: Scalars['ID']['input'];
  type: ReportPdfType;
};


export type MutationGenerateReportSummaryArgs = {
  field: SummaryField;
  reportId: Scalars['ID']['input'];
};


export type MutationMarkReportCompleteArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationMarkReportReadyForReviewArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationNotifyNewReviewersArgs = {
  reportId: Scalars['ID']['input'];
};


export type MutationRedeemUserMagicAuthTokenArgs = {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSendReportPdfArgs = {
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  reportId: Scalars['ID']['input'];
  type: ReportPdfType;
};


export type MutationSendUserMagicAuthLinkArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateAnalysesArgs = {
  data: Array<AnalysisUpdateArgs>;
};


export type MutationUpdateAnalysisArgs = {
  data: AnalysisUpdateInput;
  where: AnalysisWhereUniqueInput;
};


export type MutationUpdateEventArgs = {
  data: EventUpdateInput;
  where: EventWhereUniqueInput;
};


export type MutationUpdateEventsArgs = {
  data: Array<EventUpdateArgs>;
};


export type MutationUpdateFieldWorkArgs = {
  data: FieldWorkUpdateInput;
  where: FieldWorkWhereUniqueInput;
};


export type MutationUpdateFieldWorksArgs = {
  data: Array<FieldWorkUpdateArgs>;
};


export type MutationUpdateFireAssessmentCategoriesArgs = {
  data: Array<FireAssessmentCategoryUpdateArgs>;
};


export type MutationUpdateFireAssessmentCategoryArgs = {
  data: FireAssessmentCategoryUpdateInput;
  where: FireAssessmentCategoryWhereUniqueInput;
};


export type MutationUpdateObservationArgs = {
  data: ObservationUpdateInput;
  where: ObservationWhereUniqueInput;
};


export type MutationUpdateObservationsArgs = {
  data: Array<ObservationUpdateArgs>;
};


export type MutationUpdatePlaceholderArgs = {
  data: PlaceholderUpdateInput;
  where: PlaceholderWhereUniqueInput;
};


export type MutationUpdatePlaceholdersArgs = {
  data: Array<PlaceholderUpdateArgs>;
};


export type MutationUpdatePropertyInformationArgs = {
  data: PropertyInformationUpdateInput;
  where: PropertyInformationWhereUniqueInput;
};


export type MutationUpdatePropertyInformationsArgs = {
  data: Array<PropertyInformationUpdateArgs>;
};


export type MutationUpdateRelationshipArgs = {
  data: RelationshipUpdateInput;
  where: RelationshipWhereUniqueInput;
};


export type MutationUpdateRelationshipsArgs = {
  data: Array<RelationshipUpdateArgs>;
};


export type MutationUpdateReportArgs = {
  data: ReportUpdateInput;
  where: ReportWhereUniqueInput;
};


export type MutationUpdateReportReferenceArgs = {
  data: ReportReferenceUpdateInput;
  where: ReportReferenceWhereUniqueInput;
};


export type MutationUpdateReportReferencesArgs = {
  data: Array<ReportReferenceUpdateArgs>;
};


export type MutationUpdateReportReviewArgs = {
  data: ReportReviewUpdateInput;
  where: ReportReviewWhereUniqueInput;
};


export type MutationUpdateReportReviewsArgs = {
  data: Array<ReportReviewUpdateArgs>;
};


export type MutationUpdateReportStageArgs = {
  data: ReportStageUpdateInput;
  where: ReportStageWhereUniqueInput;
};


export type MutationUpdateReportStagesArgs = {
  data: Array<ReportStageUpdateArgs>;
};


export type MutationUpdateReportStatusArgs = {
  data: ReportStatusUpdateInput;
  where: ReportStatusWhereUniqueInput;
};


export type MutationUpdateReportStatusesArgs = {
  data: Array<ReportStatusUpdateArgs>;
};


export type MutationUpdateReportSummariesArgs = {
  data: Array<ReportSummaryUpdateArgs>;
};


export type MutationUpdateReportSummaryArgs = {
  data: ReportSummaryUpdateInput;
  where: ReportSummaryWhereUniqueInput;
};


export type MutationUpdateReportTypeArgs = {
  data: ReportTypeUpdateInput;
  where: ReportTypeWhereUniqueInput;
};


export type MutationUpdateReportTypesArgs = {
  data: Array<ReportTypeUpdateArgs>;
};


export type MutationUpdateReportsArgs = {
  data: Array<ReportUpdateArgs>;
};


export type MutationUpdateSettingArgs = {
  data: SettingUpdateInput;
  where?: SettingWhereUniqueInput;
};


export type MutationUpdateSettingsArgs = {
  data: Array<SettingUpdateArgs>;
};


export type MutationUpdateUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUsersArgs = {
  data: Array<UserUpdateArgs>;
};


export type MutationUpdateWitnessInterviewArgs = {
  data: WitnessInterviewUpdateInput;
  where: WitnessInterviewWhereUniqueInput;
};


export type MutationUpdateWitnessInterviewsArgs = {
  data: Array<WitnessInterviewUpdateArgs>;
};


export type MutationUploadReportPhotoArgs = {
  file: Scalars['Upload']['input'];
  reportId: Scalars['ID']['input'];
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Observation = {
  __typename?: 'Observation';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ObservationCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ObservationUpdateArgs = {
  data: ObservationUpdateInput;
  where: ObservationWhereUniqueInput;
};

export type ObservationUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ObservationWhereInput = {
  AND?: InputMaybe<Array<ObservationWhereInput>>;
  NOT?: InputMaybe<Array<ObservationWhereInput>>;
  OR?: InputMaybe<Array<ObservationWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ObservationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type PasswordFilter = {
  isSet: Scalars['Boolean']['input'];
};

export type PasswordState = {
  __typename?: 'PasswordState';
  isSet: Scalars['Boolean']['output'];
};

export type Placeholder = {
  __typename?: 'Placeholder';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type PlaceholderCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceholderOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type PlaceholderUpdateArgs = {
  data: PlaceholderUpdateInput;
  where: PlaceholderWhereUniqueInput;
};

export type PlaceholderUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PlaceholderWhereInput = {
  AND?: InputMaybe<Array<PlaceholderWhereInput>>;
  NOT?: InputMaybe<Array<PlaceholderWhereInput>>;
  OR?: InputMaybe<Array<PlaceholderWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  title?: InputMaybe<StringFilter>;
};

export type PlaceholderWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type PropertyInformation = {
  __typename?: 'PropertyInformation';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inspectionAddress?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  report?: Maybe<Report>;
  riskAddress?: Maybe<Scalars['String']['output']>;
};

export type PropertyInformationCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  inspectionAddress?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  report?: InputMaybe<ReportRelateToOneForCreateInput>;
  riskAddress?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyInformationOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  inspectionAddress?: InputMaybe<OrderDirection>;
  latitude?: InputMaybe<OrderDirection>;
  longitude?: InputMaybe<OrderDirection>;
  riskAddress?: InputMaybe<OrderDirection>;
};

export type PropertyInformationRelateToOneForCreateInput = {
  connect?: InputMaybe<PropertyInformationWhereUniqueInput>;
  create?: InputMaybe<PropertyInformationCreateInput>;
};

export type PropertyInformationRelateToOneForUpdateInput = {
  connect?: InputMaybe<PropertyInformationWhereUniqueInput>;
  create?: InputMaybe<PropertyInformationCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PropertyInformationUpdateArgs = {
  data: PropertyInformationUpdateInput;
  where: PropertyInformationWhereUniqueInput;
};

export type PropertyInformationUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  inspectionAddress?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  report?: InputMaybe<ReportRelateToOneForUpdateInput>;
  riskAddress?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyInformationWhereInput = {
  AND?: InputMaybe<Array<PropertyInformationWhereInput>>;
  NOT?: InputMaybe<Array<PropertyInformationWhereInput>>;
  OR?: InputMaybe<Array<PropertyInformationWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  inspectionAddress?: InputMaybe<StringFilter>;
  latitude?: InputMaybe<FloatNullableFilter>;
  longitude?: InputMaybe<FloatNullableFilter>;
  report?: InputMaybe<ReportWhereInput>;
  riskAddress?: InputMaybe<StringFilter>;
};

export type PropertyInformationWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  report?: InputMaybe<ReportWhereUniqueInput>;
};

export type Query = {
  __typename?: 'Query';
  _uploadPlaceholder?: Maybe<Scalars['Boolean']['output']>;
  analyses?: Maybe<Array<Analysis>>;
  analysesCount?: Maybe<Scalars['Int']['output']>;
  analysis?: Maybe<Analysis>;
  authenticatedItem?: Maybe<AuthenticatedItem>;
  event?: Maybe<Event>;
  events?: Maybe<Array<Event>>;
  eventsCount?: Maybe<Scalars['Int']['output']>;
  fieldWork?: Maybe<FieldWork>;
  fieldWorks?: Maybe<Array<FieldWork>>;
  fieldWorksCount?: Maybe<Scalars['Int']['output']>;
  fireAssessmentCategories?: Maybe<Array<FireAssessmentCategory>>;
  fireAssessmentCategoriesCount?: Maybe<Scalars['Int']['output']>;
  fireAssessmentCategory?: Maybe<FireAssessmentCategory>;
  keystone: KeystoneMeta;
  observation?: Maybe<Observation>;
  observations?: Maybe<Array<Observation>>;
  observationsCount?: Maybe<Scalars['Int']['output']>;
  placeholder?: Maybe<Placeholder>;
  placeholders?: Maybe<Array<Placeholder>>;
  placeholdersCount?: Maybe<Scalars['Int']['output']>;
  propertyInformation?: Maybe<PropertyInformation>;
  propertyInformations?: Maybe<Array<PropertyInformation>>;
  propertyInformationsCount?: Maybe<Scalars['Int']['output']>;
  relationship?: Maybe<Relationship>;
  relationships?: Maybe<Array<Relationship>>;
  relationshipsCount?: Maybe<Scalars['Int']['output']>;
  report?: Maybe<Report>;
  reportReference?: Maybe<ReportReference>;
  reportReferences?: Maybe<Array<ReportReference>>;
  reportReferencesCount?: Maybe<Scalars['Int']['output']>;
  reportReview?: Maybe<ReportReview>;
  reportReviews?: Maybe<Array<ReportReview>>;
  reportReviewsCount?: Maybe<Scalars['Int']['output']>;
  reportStage?: Maybe<ReportStage>;
  reportStages?: Maybe<Array<ReportStage>>;
  reportStagesCount?: Maybe<Scalars['Int']['output']>;
  reportStatus?: Maybe<ReportStatus>;
  reportStatuses?: Maybe<Array<ReportStatus>>;
  reportStatusesCount?: Maybe<Scalars['Int']['output']>;
  reportSummaries?: Maybe<Array<ReportSummary>>;
  reportSummariesCount?: Maybe<Scalars['Int']['output']>;
  reportSummary?: Maybe<ReportSummary>;
  reportType?: Maybe<ReportType>;
  reportTypes?: Maybe<Array<ReportType>>;
  reportTypesCount?: Maybe<Scalars['Int']['output']>;
  reports?: Maybe<Array<Report>>;
  reportsCount?: Maybe<Scalars['Int']['output']>;
  setting?: Maybe<Setting>;
  settings?: Maybe<Array<Setting>>;
  settingsCount?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  users?: Maybe<Array<User>>;
  usersCount?: Maybe<Scalars['Int']['output']>;
  witnessInterview?: Maybe<WitnessInterview>;
  witnessInterviews?: Maybe<Array<WitnessInterview>>;
  witnessInterviewsCount?: Maybe<Scalars['Int']['output']>;
};


export type QueryAnalysesArgs = {
  cursor?: InputMaybe<AnalysisWhereUniqueInput>;
  orderBy?: Array<AnalysisOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: AnalysisWhereInput;
};


export type QueryAnalysesCountArgs = {
  where?: AnalysisWhereInput;
};


export type QueryAnalysisArgs = {
  where: AnalysisWhereUniqueInput;
};


export type QueryEventArgs = {
  where: EventWhereUniqueInput;
};


export type QueryEventsArgs = {
  cursor?: InputMaybe<EventWhereUniqueInput>;
  orderBy?: Array<EventOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: EventWhereInput;
};


export type QueryEventsCountArgs = {
  where?: EventWhereInput;
};


export type QueryFieldWorkArgs = {
  where: FieldWorkWhereUniqueInput;
};


export type QueryFieldWorksArgs = {
  cursor?: InputMaybe<FieldWorkWhereUniqueInput>;
  orderBy?: Array<FieldWorkOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: FieldWorkWhereInput;
};


export type QueryFieldWorksCountArgs = {
  where?: FieldWorkWhereInput;
};


export type QueryFireAssessmentCategoriesArgs = {
  cursor?: InputMaybe<FireAssessmentCategoryWhereUniqueInput>;
  orderBy?: Array<FireAssessmentCategoryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: FireAssessmentCategoryWhereInput;
};


export type QueryFireAssessmentCategoriesCountArgs = {
  where?: FireAssessmentCategoryWhereInput;
};


export type QueryFireAssessmentCategoryArgs = {
  where: FireAssessmentCategoryWhereUniqueInput;
};


export type QueryObservationArgs = {
  where: ObservationWhereUniqueInput;
};


export type QueryObservationsArgs = {
  cursor?: InputMaybe<ObservationWhereUniqueInput>;
  orderBy?: Array<ObservationOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ObservationWhereInput;
};


export type QueryObservationsCountArgs = {
  where?: ObservationWhereInput;
};


export type QueryPlaceholderArgs = {
  where: PlaceholderWhereUniqueInput;
};


export type QueryPlaceholdersArgs = {
  cursor?: InputMaybe<PlaceholderWhereUniqueInput>;
  orderBy?: Array<PlaceholderOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PlaceholderWhereInput;
};


export type QueryPlaceholdersCountArgs = {
  where?: PlaceholderWhereInput;
};


export type QueryPropertyInformationArgs = {
  where: PropertyInformationWhereUniqueInput;
};


export type QueryPropertyInformationsArgs = {
  cursor?: InputMaybe<PropertyInformationWhereUniqueInput>;
  orderBy?: Array<PropertyInformationOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: PropertyInformationWhereInput;
};


export type QueryPropertyInformationsCountArgs = {
  where?: PropertyInformationWhereInput;
};


export type QueryRelationshipArgs = {
  where: RelationshipWhereUniqueInput;
};


export type QueryRelationshipsArgs = {
  cursor?: InputMaybe<RelationshipWhereUniqueInput>;
  orderBy?: Array<RelationshipOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: RelationshipWhereInput;
};


export type QueryRelationshipsCountArgs = {
  where?: RelationshipWhereInput;
};


export type QueryReportArgs = {
  where: ReportWhereUniqueInput;
};


export type QueryReportReferenceArgs = {
  where: ReportReferenceWhereUniqueInput;
};


export type QueryReportReferencesArgs = {
  cursor?: InputMaybe<ReportReferenceWhereUniqueInput>;
  orderBy?: Array<ReportReferenceOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReportReferenceWhereInput;
};


export type QueryReportReferencesCountArgs = {
  where?: ReportReferenceWhereInput;
};


export type QueryReportReviewArgs = {
  where: ReportReviewWhereUniqueInput;
};


export type QueryReportReviewsArgs = {
  cursor?: InputMaybe<ReportReviewWhereUniqueInput>;
  orderBy?: Array<ReportReviewOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReportReviewWhereInput;
};


export type QueryReportReviewsCountArgs = {
  where?: ReportReviewWhereInput;
};


export type QueryReportStageArgs = {
  where: ReportStageWhereUniqueInput;
};


export type QueryReportStagesArgs = {
  cursor?: InputMaybe<ReportStageWhereUniqueInput>;
  orderBy?: Array<ReportStageOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReportStageWhereInput;
};


export type QueryReportStagesCountArgs = {
  where?: ReportStageWhereInput;
};


export type QueryReportStatusArgs = {
  where: ReportStatusWhereUniqueInput;
};


export type QueryReportStatusesArgs = {
  cursor?: InputMaybe<ReportStatusWhereUniqueInput>;
  orderBy?: Array<ReportStatusOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReportStatusWhereInput;
};


export type QueryReportStatusesCountArgs = {
  where?: ReportStatusWhereInput;
};


export type QueryReportSummariesArgs = {
  cursor?: InputMaybe<ReportSummaryWhereUniqueInput>;
  orderBy?: Array<ReportSummaryOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReportSummaryWhereInput;
};


export type QueryReportSummariesCountArgs = {
  where?: ReportSummaryWhereInput;
};


export type QueryReportSummaryArgs = {
  where: ReportSummaryWhereUniqueInput;
};


export type QueryReportTypeArgs = {
  where: ReportTypeWhereUniqueInput;
};


export type QueryReportTypesArgs = {
  cursor?: InputMaybe<ReportTypeWhereUniqueInput>;
  orderBy?: Array<ReportTypeOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReportTypeWhereInput;
};


export type QueryReportTypesCountArgs = {
  where?: ReportTypeWhereInput;
};


export type QueryReportsArgs = {
  cursor?: InputMaybe<ReportWhereUniqueInput>;
  orderBy?: Array<ReportOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReportWhereInput;
};


export type QueryReportsCountArgs = {
  where?: ReportWhereInput;
};


export type QuerySettingArgs = {
  where?: SettingWhereUniqueInput;
};


export type QuerySettingsArgs = {
  cursor?: InputMaybe<SettingWhereUniqueInput>;
  orderBy?: Array<SettingOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: SettingWhereInput;
};


export type QuerySettingsCountArgs = {
  where?: SettingWhereInput;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserWhereInput;
};


export type QueryUsersCountArgs = {
  where?: UserWhereInput;
};


export type QueryWitnessInterviewArgs = {
  where: WitnessInterviewWhereUniqueInput;
};


export type QueryWitnessInterviewsArgs = {
  cursor?: InputMaybe<WitnessInterviewWhereUniqueInput>;
  orderBy?: Array<WitnessInterviewOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: WitnessInterviewWhereInput;
};


export type QueryWitnessInterviewsCountArgs = {
  where?: WitnessInterviewWhereInput;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type RedeemUserMagicAuthTokenFailure = {
  __typename?: 'RedeemUserMagicAuthTokenFailure';
  code: MagicLinkRedemptionErrorCode;
  message: Scalars['String']['output'];
};

export type RedeemUserMagicAuthTokenResult = RedeemUserMagicAuthTokenFailure | RedeemUserMagicAuthTokenSuccess;

export type RedeemUserMagicAuthTokenSuccess = {
  __typename?: 'RedeemUserMagicAuthTokenSuccess';
  item: User;
  token: Scalars['String']['output'];
};

export type Relationship = {
  __typename?: 'Relationship';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type RelationshipCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RelationshipOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  description?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type RelationshipUpdateArgs = {
  data: RelationshipUpdateInput;
  where: RelationshipWhereUniqueInput;
};

export type RelationshipUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RelationshipWhereInput = {
  AND?: InputMaybe<Array<RelationshipWhereInput>>;
  NOT?: InputMaybe<Array<RelationshipWhereInput>>;
  OR?: InputMaybe<Array<RelationshipWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type RelationshipWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Report = {
  __typename?: 'Report';
  analysis?: Maybe<Analysis>;
  assessor?: Maybe<User>;
  asset?: Maybe<Scalars['String']['output']>;
  attendees?: Maybe<Scalars['JSON']['output']>;
  broker?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  dateOfInspection?: Maybe<Scalars['DateTime']['output']>;
  dateOfLoss?: Maybe<Scalars['DateTime']['output']>;
  evidence?: Maybe<Scalars['JSON']['output']>;
  fieldWork?: Maybe<FieldWork>;
  id: Scalars['ID']['output'];
  insurer?: Maybe<Scalars['String']['output']>;
  propertyInformation?: Maybe<PropertyInformation>;
  references?: Maybe<Array<ReportReference>>;
  referencesCount?: Maybe<Scalars['Int']['output']>;
  reportType?: Maybe<ReportType>;
  reviews?: Maybe<Array<ReportReview>>;
  reviewsCount?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<ReportStage>;
  status?: Maybe<ReportStatus>;
  summary?: Maybe<ReportSummary>;
  weatherCondition?: Maybe<Scalars['JSON']['output']>;
  weatherLeadInDays?: Maybe<Scalars['Int']['output']>;
  witnessInterviews?: Maybe<Array<WitnessInterview>>;
  witnessInterviewsCount?: Maybe<Scalars['Int']['output']>;
};


export type ReportReferencesArgs = {
  cursor?: InputMaybe<ReportReferenceWhereUniqueInput>;
  orderBy?: Array<ReportReferenceOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReportReferenceWhereInput;
};


export type ReportReferencesCountArgs = {
  where?: ReportReferenceWhereInput;
};


export type ReportReviewsArgs = {
  cursor?: InputMaybe<ReportReviewWhereUniqueInput>;
  orderBy?: Array<ReportReviewOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: ReportReviewWhereInput;
};


export type ReportReviewsCountArgs = {
  where?: ReportReviewWhereInput;
};


export type ReportWitnessInterviewsArgs = {
  cursor?: InputMaybe<WitnessInterviewWhereUniqueInput>;
  orderBy?: Array<WitnessInterviewOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: WitnessInterviewWhereInput;
};


export type ReportWitnessInterviewsCountArgs = {
  where?: WitnessInterviewWhereInput;
};

export type ReportCreateInput = {
  analysis?: InputMaybe<AnalysisRelateToOneForCreateInput>;
  assessor?: InputMaybe<UserRelateToOneForCreateInput>;
  asset?: InputMaybe<Scalars['String']['input']>;
  attendees?: InputMaybe<Scalars['JSON']['input']>;
  broker?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfInspection?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfLoss?: InputMaybe<Scalars['DateTime']['input']>;
  evidence?: InputMaybe<Scalars['JSON']['input']>;
  fieldWork?: InputMaybe<FieldWorkRelateToOneForCreateInput>;
  insurer?: InputMaybe<Scalars['String']['input']>;
  propertyInformation?: InputMaybe<PropertyInformationRelateToOneForCreateInput>;
  references?: InputMaybe<ReportReferenceRelateToManyForCreateInput>;
  reportType?: InputMaybe<ReportTypeRelateToOneForCreateInput>;
  reviews?: InputMaybe<ReportReviewRelateToManyForCreateInput>;
  stage?: InputMaybe<ReportStageRelateToOneForCreateInput>;
  status?: InputMaybe<ReportStatusRelateToOneForCreateInput>;
  summary?: InputMaybe<ReportSummaryRelateToOneForCreateInput>;
  weatherCondition?: InputMaybe<Scalars['JSON']['input']>;
  weatherLeadInDays?: InputMaybe<Scalars['Int']['input']>;
  witnessInterviews?: InputMaybe<WitnessInterviewRelateToManyForCreateInput>;
};

export type ReportOrderByInput = {
  asset?: InputMaybe<OrderDirection>;
  broker?: InputMaybe<OrderDirection>;
  client?: InputMaybe<OrderDirection>;
  code?: InputMaybe<OrderDirection>;
  completedAt?: InputMaybe<OrderDirection>;
  created_at?: InputMaybe<OrderDirection>;
  dateOfInspection?: InputMaybe<OrderDirection>;
  dateOfLoss?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  insurer?: InputMaybe<OrderDirection>;
  weatherLeadInDays?: InputMaybe<OrderDirection>;
};

export enum ReportPdfType {
  Standard = 'standard',
  Summary = 'summary'
}

export type ReportReadyForReviewView = {
  __typename?: 'ReportReadyForReviewView';
  client?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  emailsFailed: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  notifiedReviewerIds: Array<Scalars['ID']['output']>;
  stage?: Maybe<ReportStageRef>;
};

export type ReportReference = {
  __typename?: 'ReportReference';
  claimNumber?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  jobNumber?: Maybe<Scalars['String']['output']>;
  refNumber?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
};

export type ReportReferenceCreateInput = {
  claimNumber?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  jobNumber?: InputMaybe<Scalars['String']['input']>;
  refNumber?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ReportRelateToOneForCreateInput>;
};

export type ReportReferenceManyRelationFilter = {
  every?: InputMaybe<ReportReferenceWhereInput>;
  none?: InputMaybe<ReportReferenceWhereInput>;
  some?: InputMaybe<ReportReferenceWhereInput>;
};

export type ReportReferenceOrderByInput = {
  claimNumber?: InputMaybe<OrderDirection>;
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  jobNumber?: InputMaybe<OrderDirection>;
  refNumber?: InputMaybe<OrderDirection>;
};

export type ReportReferenceRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ReportReferenceWhereUniqueInput>>;
  create?: InputMaybe<Array<ReportReferenceCreateInput>>;
};

export type ReportReferenceRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ReportReferenceWhereUniqueInput>>;
  create?: InputMaybe<Array<ReportReferenceCreateInput>>;
  disconnect?: InputMaybe<Array<ReportReferenceWhereUniqueInput>>;
  set?: InputMaybe<Array<ReportReferenceWhereUniqueInput>>;
};

export type ReportReferenceUpdateArgs = {
  data: ReportReferenceUpdateInput;
  where: ReportReferenceWhereUniqueInput;
};

export type ReportReferenceUpdateInput = {
  claimNumber?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  jobNumber?: InputMaybe<Scalars['String']['input']>;
  refNumber?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ReportRelateToOneForUpdateInput>;
};

export type ReportReferenceWhereInput = {
  AND?: InputMaybe<Array<ReportReferenceWhereInput>>;
  NOT?: InputMaybe<Array<ReportReferenceWhereInput>>;
  OR?: InputMaybe<Array<ReportReferenceWhereInput>>;
  claimNumber?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  jobNumber?: InputMaybe<StringFilter>;
  refNumber?: InputMaybe<StringFilter>;
  report?: InputMaybe<ReportWhereInput>;
};

export type ReportReferenceWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReportRelateToOneForCreateInput = {
  connect?: InputMaybe<ReportWhereUniqueInput>;
  create?: InputMaybe<ReportCreateInput>;
};

export type ReportRelateToOneForUpdateInput = {
  connect?: InputMaybe<ReportWhereUniqueInput>;
  create?: InputMaybe<ReportCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportReview = {
  __typename?: 'ReportReview';
  circumstancesSummary?: Maybe<Scalars['JSON']['output']>;
  clientInformation?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  executiveSummary?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  keyConclusions?: Maybe<Scalars['JSON']['output']>;
  notifiedReviewers?: Maybe<Array<User>>;
  notifiedReviewersCount?: Maybe<Scalars['Int']['output']>;
  otherFactorsConsidered?: Maybe<Scalars['JSON']['output']>;
  overallComments?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Scalars['JSON']['output']>;
  report?: Maybe<Report>;
  reviewers?: Maybe<Array<User>>;
  reviewersCount?: Maybe<Scalars['Int']['output']>;
  scope?: Maybe<Scalars['JSON']['output']>;
  siteAccess?: Maybe<Scalars['JSON']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  weatherConditions?: Maybe<Scalars['JSON']['output']>;
  witnessStatements?: Maybe<Scalars['JSON']['output']>;
};


export type ReportReviewNotifiedReviewersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserWhereInput;
};


export type ReportReviewNotifiedReviewersCountArgs = {
  where?: UserWhereInput;
};


export type ReportReviewReviewersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: Array<UserOrderByInput>;
  skip?: Scalars['Int']['input'];
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: UserWhereInput;
};


export type ReportReviewReviewersCountArgs = {
  where?: UserWhereInput;
};

export type ReportReviewCreateInput = {
  circumstancesSummary?: InputMaybe<Scalars['JSON']['input']>;
  clientInformation?: InputMaybe<Scalars['JSON']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  executiveSummary?: InputMaybe<Scalars['JSON']['input']>;
  keyConclusions?: InputMaybe<Scalars['JSON']['input']>;
  notifiedReviewers?: InputMaybe<UserRelateToManyForCreateInput>;
  otherFactorsConsidered?: InputMaybe<Scalars['JSON']['input']>;
  overallComments?: InputMaybe<Scalars['String']['input']>;
  recommendations?: InputMaybe<Scalars['JSON']['input']>;
  report?: InputMaybe<ReportRelateToOneForCreateInput>;
  reviewers?: InputMaybe<UserRelateToManyForCreateInput>;
  scope?: InputMaybe<Scalars['JSON']['input']>;
  siteAccess?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weatherConditions?: InputMaybe<Scalars['JSON']['input']>;
  witnessStatements?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReportReviewManyRelationFilter = {
  every?: InputMaybe<ReportReviewWhereInput>;
  none?: InputMaybe<ReportReviewWhereInput>;
  some?: InputMaybe<ReportReviewWhereInput>;
};

export type ReportReviewOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  overallComments?: InputMaybe<OrderDirection>;
  status?: InputMaybe<OrderDirection>;
  submittedAt?: InputMaybe<OrderDirection>;
};

export type ReportReviewRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<ReportReviewWhereUniqueInput>>;
  create?: InputMaybe<Array<ReportReviewCreateInput>>;
};

export type ReportReviewRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<ReportReviewWhereUniqueInput>>;
  create?: InputMaybe<Array<ReportReviewCreateInput>>;
  disconnect?: InputMaybe<Array<ReportReviewWhereUniqueInput>>;
  set?: InputMaybe<Array<ReportReviewWhereUniqueInput>>;
};

export type ReportReviewUpdateArgs = {
  data: ReportReviewUpdateInput;
  where: ReportReviewWhereUniqueInput;
};

export type ReportReviewUpdateInput = {
  circumstancesSummary?: InputMaybe<Scalars['JSON']['input']>;
  clientInformation?: InputMaybe<Scalars['JSON']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  executiveSummary?: InputMaybe<Scalars['JSON']['input']>;
  keyConclusions?: InputMaybe<Scalars['JSON']['input']>;
  notifiedReviewers?: InputMaybe<UserRelateToManyForUpdateInput>;
  otherFactorsConsidered?: InputMaybe<Scalars['JSON']['input']>;
  overallComments?: InputMaybe<Scalars['String']['input']>;
  recommendations?: InputMaybe<Scalars['JSON']['input']>;
  report?: InputMaybe<ReportRelateToOneForUpdateInput>;
  reviewers?: InputMaybe<UserRelateToManyForUpdateInput>;
  scope?: InputMaybe<Scalars['JSON']['input']>;
  siteAccess?: InputMaybe<Scalars['JSON']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  submittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  weatherConditions?: InputMaybe<Scalars['JSON']['input']>;
  witnessStatements?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReportReviewWhereInput = {
  AND?: InputMaybe<Array<ReportReviewWhereInput>>;
  NOT?: InputMaybe<Array<ReportReviewWhereInput>>;
  OR?: InputMaybe<Array<ReportReviewWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  notifiedReviewers?: InputMaybe<UserManyRelationFilter>;
  overallComments?: InputMaybe<StringFilter>;
  report?: InputMaybe<ReportWhereInput>;
  reviewers?: InputMaybe<UserManyRelationFilter>;
  status?: InputMaybe<StringNullableFilter>;
  submittedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type ReportReviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ReportStage = {
  __typename?: 'ReportStage';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ReportStageCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportStageOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ReportStageRef = {
  __typename?: 'ReportStageRef';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ReportStageRelateToOneForCreateInput = {
  connect?: InputMaybe<ReportStageWhereUniqueInput>;
  create?: InputMaybe<ReportStageCreateInput>;
};

export type ReportStageRelateToOneForUpdateInput = {
  connect?: InputMaybe<ReportStageWhereUniqueInput>;
  create?: InputMaybe<ReportStageCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportStageUpdateArgs = {
  data: ReportStageUpdateInput;
  where: ReportStageWhereUniqueInput;
};

export type ReportStageUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportStageView = {
  __typename?: 'ReportStageView';
  client?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  stage?: Maybe<ReportStageRef>;
};

export type ReportStageWhereInput = {
  AND?: InputMaybe<Array<ReportStageWhereInput>>;
  NOT?: InputMaybe<Array<ReportStageWhereInput>>;
  OR?: InputMaybe<Array<ReportStageWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ReportStageWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportStatus = {
  __typename?: 'ReportStatus';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ReportStatusCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportStatusOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ReportStatusRelateToOneForCreateInput = {
  connect?: InputMaybe<ReportStatusWhereUniqueInput>;
  create?: InputMaybe<ReportStatusCreateInput>;
};

export type ReportStatusRelateToOneForUpdateInput = {
  connect?: InputMaybe<ReportStatusWhereUniqueInput>;
  create?: InputMaybe<ReportStatusCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportStatusUpdateArgs = {
  data: ReportStatusUpdateInput;
  where: ReportStatusWhereUniqueInput;
};

export type ReportStatusUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportStatusWhereInput = {
  AND?: InputMaybe<Array<ReportStatusWhereInput>>;
  NOT?: InputMaybe<Array<ReportStatusWhereInput>>;
  OR?: InputMaybe<Array<ReportStatusWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ReportStatusWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportSummary = {
  __typename?: 'ReportSummary';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  executiveSummary?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  keyConclusions?: Maybe<Scalars['String']['output']>;
  recommendations?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
  scope?: Maybe<Scalars['String']['output']>;
  scopeItems?: Maybe<Scalars['JSON']['output']>;
};

export type ReportSummaryCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  executiveSummary?: InputMaybe<Scalars['String']['input']>;
  keyConclusions?: InputMaybe<Scalars['String']['input']>;
  recommendations?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ReportRelateToOneForCreateInput>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scopeItems?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReportSummaryOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  executiveSummary?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  keyConclusions?: InputMaybe<OrderDirection>;
  recommendations?: InputMaybe<OrderDirection>;
  scope?: InputMaybe<OrderDirection>;
};

export type ReportSummaryRelateToOneForCreateInput = {
  connect?: InputMaybe<ReportSummaryWhereUniqueInput>;
  create?: InputMaybe<ReportSummaryCreateInput>;
};

export type ReportSummaryRelateToOneForUpdateInput = {
  connect?: InputMaybe<ReportSummaryWhereUniqueInput>;
  create?: InputMaybe<ReportSummaryCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportSummaryUpdateArgs = {
  data: ReportSummaryUpdateInput;
  where: ReportSummaryWhereUniqueInput;
};

export type ReportSummaryUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  executiveSummary?: InputMaybe<Scalars['String']['input']>;
  keyConclusions?: InputMaybe<Scalars['String']['input']>;
  recommendations?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ReportRelateToOneForUpdateInput>;
  scope?: InputMaybe<Scalars['String']['input']>;
  scopeItems?: InputMaybe<Scalars['JSON']['input']>;
};

export type ReportSummaryWhereInput = {
  AND?: InputMaybe<Array<ReportSummaryWhereInput>>;
  NOT?: InputMaybe<Array<ReportSummaryWhereInput>>;
  OR?: InputMaybe<Array<ReportSummaryWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  executiveSummary?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<IdFilter>;
  keyConclusions?: InputMaybe<StringNullableFilter>;
  recommendations?: InputMaybe<StringNullableFilter>;
  report?: InputMaybe<ReportWhereInput>;
  scope?: InputMaybe<StringNullableFilter>;
};

export type ReportSummaryWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  report?: InputMaybe<ReportWhereUniqueInput>;
};

export type ReportType = {
  __typename?: 'ReportType';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ReportTypeCreateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTypeOrderByInput = {
  created_at?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
};

export type ReportTypeRelateToOneForCreateInput = {
  connect?: InputMaybe<ReportTypeWhereUniqueInput>;
  create?: InputMaybe<ReportTypeCreateInput>;
};

export type ReportTypeRelateToOneForUpdateInput = {
  connect?: InputMaybe<ReportTypeWhereUniqueInput>;
  create?: InputMaybe<ReportTypeCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ReportTypeUpdateArgs = {
  data: ReportTypeUpdateInput;
  where: ReportTypeWhereUniqueInput;
};

export type ReportTypeUpdateInput = {
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTypeWhereInput = {
  AND?: InputMaybe<Array<ReportTypeWhereInput>>;
  NOT?: InputMaybe<Array<ReportTypeWhereInput>>;
  OR?: InputMaybe<Array<ReportTypeWhereInput>>;
  created_at?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<IdFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ReportTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type ReportUpdateArgs = {
  data: ReportUpdateInput;
  where: ReportWhereUniqueInput;
};

export type ReportUpdateInput = {
  analysis?: InputMaybe<AnalysisRelateToOneForUpdateInput>;
  assessor?: InputMaybe<UserRelateToOneForUpdateInput>;
  asset?: InputMaybe<Scalars['String']['input']>;
  attendees?: InputMaybe<Scalars['JSON']['input']>;
  broker?: InputMaybe<Scalars['String']['input']>;
  client?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfInspection?: InputMaybe<Scalars['DateTime']['input']>;
  dateOfLoss?: InputMaybe<Scalars['DateTime']['input']>;
  evidence?: InputMaybe<Scalars['JSON']['input']>;
  fieldWork?: InputMaybe<FieldWorkRelateToOneForUpdateInput>;
  insurer?: InputMaybe<Scalars['String']['input']>;
  propertyInformation?: InputMaybe<PropertyInformationRelateToOneForUpdateInput>;
  references?: InputMaybe<ReportReferenceRelateToManyForUpdateInput>;
  reportType?: InputMaybe<ReportTypeRelateToOneForUpdateInput>;
  reviews?: InputMaybe<ReportReviewRelateToManyForUpdateInput>;
  stage?: InputMaybe<ReportStageRelateToOneForUpdateInput>;
  status?: InputMaybe<ReportStatusRelateToOneForUpdateInput>;
  summary?: InputMaybe<ReportSummaryRelateToOneForUpdateInput>;
  weatherCondition?: InputMaybe<Scalars['JSON']['input']>;
  weatherLeadInDays?: InputMaybe<Scalars['Int']['input']>;
  witnessInterviews?: InputMaybe<WitnessInterviewRelateToManyForUpdateInput>;
};

export type ReportWhereInput = {
  AND?: InputMaybe<Array<ReportWhereInput>>;
  NOT?: InputMaybe<Array<ReportWhereInput>>;
  OR?: InputMaybe<Array<ReportWhereInput>>;
  analysis?: InputMaybe<AnalysisWhereInput>;
  assessor?: InputMaybe<UserWhereInput>;
  asset?: InputMaybe<StringFilter>;
  broker?: InputMaybe<StringFilter>;
  client?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  completedAt?: InputMaybe<DateTimeNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  dateOfInspection?: InputMaybe<DateTimeNullableFilter>;
  dateOfLoss?: InputMaybe<DateTimeNullableFilter>;
  fieldWork?: InputMaybe<FieldWorkWhereInput>;
  id?: InputMaybe<IdFilter>;
  insurer?: InputMaybe<StringFilter>;
  propertyInformation?: InputMaybe<PropertyInformationWhereInput>;
  references?: InputMaybe<ReportReferenceManyRelationFilter>;
  reportType?: InputMaybe<ReportTypeWhereInput>;
  reviews?: InputMaybe<ReportReviewManyRelationFilter>;
  stage?: InputMaybe<ReportStageWhereInput>;
  status?: InputMaybe<ReportStatusWhereInput>;
  summary?: InputMaybe<ReportSummaryWhereInput>;
  weatherLeadInDays?: InputMaybe<IntNullableFilter>;
  witnessInterviews?: InputMaybe<WitnessInterviewManyRelationFilter>;
};

export type ReportWhereUniqueInput = {
  analysis?: InputMaybe<AnalysisWhereUniqueInput>;
  code?: InputMaybe<Scalars['String']['input']>;
  fieldWork?: InputMaybe<FieldWorkWhereUniqueInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  propertyInformation?: InputMaybe<PropertyInformationWhereUniqueInput>;
  summary?: InputMaybe<ReportSummaryWhereUniqueInput>;
};

export type ReviewerNotification = {
  __typename?: 'ReviewerNotification';
  emailsFailed: Scalars['Int']['output'];
  notifiedReviewerIds: Array<Scalars['ID']['output']>;
};

export type SendReportPdfResult = {
  __typename?: 'SendReportPdfResult';
  recipientCount: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

export type Setting = {
  __typename?: 'Setting';
  areaOfOriginOptions?: Maybe<Scalars['JSON']['output']>;
  attendeeOrganisationOptions?: Maybe<Scalars['JSON']['output']>;
  attendeeRoleOptions?: Maybe<Scalars['JSON']['output']>;
  bomApiKey?: Maybe<Scalars['String']['output']>;
  brokerOptions?: Maybe<Scalars['JSON']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  defaultSiteAccessText?: Maybe<Scalars['String']['output']>;
  defaultWeatherLeadInDays?: Maybe<Scalars['Int']['output']>;
  evidenceCategoryOptions?: Maybe<Scalars['JSON']['output']>;
  firstFuelOptions?: Maybe<Scalars['JSON']['output']>;
  googleApiKey?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  ignitionSourceOptions?: Maybe<Scalars['JSON']['output']>;
  indicatorsOptions?: Maybe<Scalars['JSON']['output']>;
  initialSiteObservationOptions?: Maybe<Scalars['JSON']['output']>;
  insurerOptions?: Maybe<Scalars['JSON']['output']>;
  openAiApiKey?: Maybe<Scalars['String']['output']>;
  pointOfOriginOptions?: Maybe<Scalars['JSON']['output']>;
  preliminaryFireAssessmentOptions?: Maybe<Scalars['JSON']['output']>;
  technicalTermsOptions?: Maybe<Scalars['JSON']['output']>;
  witnessEventOptions?: Maybe<Scalars['JSON']['output']>;
  witnessRelationshipOptions?: Maybe<Scalars['JSON']['output']>;
};

export type SettingCreateInput = {
  areaOfOriginOptions?: InputMaybe<Scalars['JSON']['input']>;
  attendeeOrganisationOptions?: InputMaybe<Scalars['JSON']['input']>;
  attendeeRoleOptions?: InputMaybe<Scalars['JSON']['input']>;
  bomApiKey?: InputMaybe<Scalars['String']['input']>;
  brokerOptions?: InputMaybe<Scalars['JSON']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  defaultSiteAccessText?: InputMaybe<Scalars['String']['input']>;
  defaultWeatherLeadInDays?: InputMaybe<Scalars['Int']['input']>;
  evidenceCategoryOptions?: InputMaybe<Scalars['JSON']['input']>;
  firstFuelOptions?: InputMaybe<Scalars['JSON']['input']>;
  googleApiKey?: InputMaybe<Scalars['String']['input']>;
  ignitionSourceOptions?: InputMaybe<Scalars['JSON']['input']>;
  indicatorsOptions?: InputMaybe<Scalars['JSON']['input']>;
  initialSiteObservationOptions?: InputMaybe<Scalars['JSON']['input']>;
  insurerOptions?: InputMaybe<Scalars['JSON']['input']>;
  openAiApiKey?: InputMaybe<Scalars['String']['input']>;
  pointOfOriginOptions?: InputMaybe<Scalars['JSON']['input']>;
  preliminaryFireAssessmentOptions?: InputMaybe<Scalars['JSON']['input']>;
  technicalTermsOptions?: InputMaybe<Scalars['JSON']['input']>;
  witnessEventOptions?: InputMaybe<Scalars['JSON']['input']>;
  witnessRelationshipOptions?: InputMaybe<Scalars['JSON']['input']>;
};

export type SettingOption = {
  __typename?: 'SettingOption';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum SettingOptionField {
  Broker = 'BROKER',
  Insurer = 'INSURER'
}

export type SettingOrderByInput = {
  bomApiKey?: InputMaybe<OrderDirection>;
  created_at?: InputMaybe<OrderDirection>;
  defaultSiteAccessText?: InputMaybe<OrderDirection>;
  defaultWeatherLeadInDays?: InputMaybe<OrderDirection>;
  googleApiKey?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  openAiApiKey?: InputMaybe<OrderDirection>;
};

export type SettingUpdateArgs = {
  data: SettingUpdateInput;
  where?: SettingWhereUniqueInput;
};

export type SettingUpdateInput = {
  areaOfOriginOptions?: InputMaybe<Scalars['JSON']['input']>;
  attendeeOrganisationOptions?: InputMaybe<Scalars['JSON']['input']>;
  attendeeRoleOptions?: InputMaybe<Scalars['JSON']['input']>;
  bomApiKey?: InputMaybe<Scalars['String']['input']>;
  brokerOptions?: InputMaybe<Scalars['JSON']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  defaultSiteAccessText?: InputMaybe<Scalars['String']['input']>;
  defaultWeatherLeadInDays?: InputMaybe<Scalars['Int']['input']>;
  evidenceCategoryOptions?: InputMaybe<Scalars['JSON']['input']>;
  firstFuelOptions?: InputMaybe<Scalars['JSON']['input']>;
  googleApiKey?: InputMaybe<Scalars['String']['input']>;
  ignitionSourceOptions?: InputMaybe<Scalars['JSON']['input']>;
  indicatorsOptions?: InputMaybe<Scalars['JSON']['input']>;
  initialSiteObservationOptions?: InputMaybe<Scalars['JSON']['input']>;
  insurerOptions?: InputMaybe<Scalars['JSON']['input']>;
  openAiApiKey?: InputMaybe<Scalars['String']['input']>;
  pointOfOriginOptions?: InputMaybe<Scalars['JSON']['input']>;
  preliminaryFireAssessmentOptions?: InputMaybe<Scalars['JSON']['input']>;
  technicalTermsOptions?: InputMaybe<Scalars['JSON']['input']>;
  witnessEventOptions?: InputMaybe<Scalars['JSON']['input']>;
  witnessRelationshipOptions?: InputMaybe<Scalars['JSON']['input']>;
};

export type SettingWhereInput = {
  AND?: InputMaybe<Array<SettingWhereInput>>;
  NOT?: InputMaybe<Array<SettingWhereInput>>;
  OR?: InputMaybe<Array<SettingWhereInput>>;
  bomApiKey?: InputMaybe<StringFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  defaultSiteAccessText?: InputMaybe<StringNullableFilter>;
  defaultWeatherLeadInDays?: InputMaybe<IntNullableFilter>;
  googleApiKey?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  openAiApiKey?: InputMaybe<StringFilter>;
};

export type SettingWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export enum SummaryField {
  ExecutiveSummary = 'executiveSummary',
  KeyConclusions = 'keyConclusions',
  Recommendations = 'recommendations',
  Scope = 'scope'
}

export type User = {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  credentials?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAdmin?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  magicAuthIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  magicAuthRedeemedAt?: Maybe<Scalars['DateTime']['output']>;
  magicAuthToken?: Maybe<PasswordState>;
  mustChangePassword?: Maybe<Scalars['Boolean']['output']>;
  password?: Maybe<PasswordState>;
  title?: Maybe<Scalars['String']['output']>;
};

export type UserAuthenticationWithPasswordFailure = {
  __typename?: 'UserAuthenticationWithPasswordFailure';
  message: Scalars['String']['output'];
};

export type UserAuthenticationWithPasswordResult = UserAuthenticationWithPasswordFailure | UserAuthenticationWithPasswordSuccess;

export type UserAuthenticationWithPasswordSuccess = {
  __typename?: 'UserAuthenticationWithPasswordSuccess';
  item: User;
  sessionToken: Scalars['String']['output'];
};

export type UserCreateInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  credentials?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  magicAuthIssuedAt?: InputMaybe<Scalars['DateTime']['input']>;
  magicAuthRedeemedAt?: InputMaybe<Scalars['DateTime']['input']>;
  magicAuthToken?: InputMaybe<Scalars['String']['input']>;
  mustChangePassword?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UserManyRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserOrderByInput = {
  avatarUrl?: InputMaybe<OrderDirection>;
  created_at?: InputMaybe<OrderDirection>;
  credentials?: InputMaybe<OrderDirection>;
  email?: InputMaybe<OrderDirection>;
  firstName?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  isAdmin?: InputMaybe<OrderDirection>;
  lastName?: InputMaybe<OrderDirection>;
  magicAuthIssuedAt?: InputMaybe<OrderDirection>;
  magicAuthRedeemedAt?: InputMaybe<OrderDirection>;
  mustChangePassword?: InputMaybe<OrderDirection>;
  title?: InputMaybe<OrderDirection>;
};

export type UserRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCreateInput>>;
};

export type UserRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  create?: InputMaybe<Array<UserCreateInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
};

export type UserRelateToOneForCreateInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  create?: InputMaybe<UserCreateInput>;
};

export type UserRelateToOneForUpdateInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  create?: InputMaybe<UserCreateInput>;
  disconnect?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserUpdateArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};

export type UserUpdateInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  credentials?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  magicAuthIssuedAt?: InputMaybe<Scalars['DateTime']['input']>;
  magicAuthRedeemedAt?: InputMaybe<Scalars['DateTime']['input']>;
  magicAuthToken?: InputMaybe<Scalars['String']['input']>;
  mustChangePassword?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UserWhereInput = {
  AND?: InputMaybe<Array<UserWhereInput>>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  avatarUrl?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  credentials?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  isAdmin?: InputMaybe<BooleanFilter>;
  lastName?: InputMaybe<StringFilter>;
  magicAuthIssuedAt?: InputMaybe<DateTimeNullableFilter>;
  magicAuthRedeemedAt?: InputMaybe<DateTimeNullableFilter>;
  magicAuthToken?: InputMaybe<PasswordFilter>;
  mustChangePassword?: InputMaybe<BooleanFilter>;
  title?: InputMaybe<StringNullableFilter>;
};

export type UserWhereUniqueInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type WitnessInterview = {
  __typename?: 'WitnessInterview';
  briefNote?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  detailedNote?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interviewDatetime?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  report?: Maybe<Report>;
  witnessRelationship?: Maybe<Scalars['String']['output']>;
};

export type WitnessInterviewCreateInput = {
  briefNote?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  detailedNote?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  interviewDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ReportRelateToOneForCreateInput>;
  witnessRelationship?: InputMaybe<Scalars['String']['input']>;
};

export type WitnessInterviewManyRelationFilter = {
  every?: InputMaybe<WitnessInterviewWhereInput>;
  none?: InputMaybe<WitnessInterviewWhereInput>;
  some?: InputMaybe<WitnessInterviewWhereInput>;
};

export type WitnessInterviewOrderByInput = {
  briefNote?: InputMaybe<OrderDirection>;
  created_at?: InputMaybe<OrderDirection>;
  detailedNote?: InputMaybe<OrderDirection>;
  event?: InputMaybe<OrderDirection>;
  id?: InputMaybe<OrderDirection>;
  interviewDatetime?: InputMaybe<OrderDirection>;
  name?: InputMaybe<OrderDirection>;
  witnessRelationship?: InputMaybe<OrderDirection>;
};

export type WitnessInterviewRelateToManyForCreateInput = {
  connect?: InputMaybe<Array<WitnessInterviewWhereUniqueInput>>;
  create?: InputMaybe<Array<WitnessInterviewCreateInput>>;
};

export type WitnessInterviewRelateToManyForUpdateInput = {
  connect?: InputMaybe<Array<WitnessInterviewWhereUniqueInput>>;
  create?: InputMaybe<Array<WitnessInterviewCreateInput>>;
  disconnect?: InputMaybe<Array<WitnessInterviewWhereUniqueInput>>;
  set?: InputMaybe<Array<WitnessInterviewWhereUniqueInput>>;
};

export type WitnessInterviewUpdateArgs = {
  data: WitnessInterviewUpdateInput;
  where: WitnessInterviewWhereUniqueInput;
};

export type WitnessInterviewUpdateInput = {
  briefNote?: InputMaybe<Scalars['String']['input']>;
  created_at?: InputMaybe<Scalars['DateTime']['input']>;
  detailedNote?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  interviewDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  report?: InputMaybe<ReportRelateToOneForUpdateInput>;
  witnessRelationship?: InputMaybe<Scalars['String']['input']>;
};

export type WitnessInterviewWhereInput = {
  AND?: InputMaybe<Array<WitnessInterviewWhereInput>>;
  NOT?: InputMaybe<Array<WitnessInterviewWhereInput>>;
  OR?: InputMaybe<Array<WitnessInterviewWhereInput>>;
  briefNote?: InputMaybe<StringNullableFilter>;
  created_at?: InputMaybe<DateTimeFilter>;
  detailedNote?: InputMaybe<StringNullableFilter>;
  event?: InputMaybe<StringFilter>;
  id?: InputMaybe<IdFilter>;
  interviewDatetime?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  report?: InputMaybe<ReportWhereInput>;
  witnessRelationship?: InputMaybe<StringFilter>;
};

export type WitnessInterviewWhereUniqueInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type GetPlaceholdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlaceholdersQuery = { __typename?: 'Query', placeholders?: Array<{ __typename?: 'Placeholder', id: string, title?: string | null }> | null };

export type GetPlaceholderQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPlaceholderQuery = { __typename?: 'Query', placeholder?: { __typename?: 'Placeholder', id: string, title?: string | null } | null };

export type CreatePlaceholderMutationVariables = Exact<{
  data: PlaceholderCreateInput;
}>;


export type CreatePlaceholderMutation = { __typename?: 'Mutation', createPlaceholder?: { __typename?: 'Placeholder', id: string, title?: string | null } | null };

export type UpdatePlaceholderMutationVariables = Exact<{
  where: PlaceholderWhereUniqueInput;
  data: PlaceholderUpdateInput;
}>;


export type UpdatePlaceholderMutation = { __typename?: 'Mutation', updatePlaceholder?: { __typename?: 'Placeholder', id: string, title?: string | null } | null };

export type DeletePlaceholderMutationVariables = Exact<{
  where: PlaceholderWhereUniqueInput;
}>;


export type DeletePlaceholderMutation = { __typename?: 'Mutation', deletePlaceholder?: { __typename?: 'Placeholder', id: string } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', authenticateUserWithPassword?:
    | { __typename?: 'UserAuthenticationWithPasswordFailure', message: string }
    | { __typename?: 'UserAuthenticationWithPasswordSuccess', sessionToken: string, item: { __typename?: 'User', id: string, email?: string | null } }
   | null };

export type UpdateUserPasswordMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateUserPasswordMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, email?: string | null } | null };

export type UpdateUserInformationMutationVariables = Exact<{
  where: UserWhereUniqueInput;
  data: UserUpdateInput;
}>;


export type UpdateUserInformationMutation = { __typename?: 'Mutation', updateUser?: { __typename?: 'User', id: string, email?: string | null, firstName?: string | null, lastName?: string | null, title?: string | null, credentials?: string | null, avatarUrl?: string | null } | null };

export type SendMagicLinkMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SendMagicLinkMutation = { __typename?: 'Mutation', sendUserMagicAuthLink: boolean };

export type CreateUserMutationVariables = Exact<{
  data: UserCreateInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser?: { __typename?: 'User', id: string, email?: string | null } | null };

export type VerifyMagicTokenMutationVariables = Exact<{
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type VerifyMagicTokenMutation = { __typename?: 'Mutation', redeemUserMagicAuthToken:
    | { __typename?: 'RedeemUserMagicAuthTokenFailure', code: MagicLinkRedemptionErrorCode, message: string }
    | { __typename?: 'RedeemUserMagicAuthTokenSuccess', token: string }
   };

export type CreateReportMutationVariables = Exact<{
  data: ReportCreateInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport?: { __typename?: 'Report', id: string, code?: string | null } | null };

export type UpdateReportMutationVariables = Exact<{
  where: ReportWhereUniqueInput;
  data: ReportUpdateInput;
}>;


export type UpdateReportMutation = { __typename?: 'Mutation', updateReport?: { __typename?: 'Report', id: string, code?: string | null, insurer?: string | null, broker?: string | null, weatherCondition?: unknown | null, weatherLeadInDays?: number | null, evidence?: unknown | null, attendees?: unknown | null, stage?: { __typename?: 'ReportStage', id: string, name?: string | null } | null, status?: { __typename?: 'ReportStatus', id: string, name?: string | null } | null, assessor?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null, reportType?: { __typename?: 'ReportType', id: string, name?: string | null } | null } | null };

export type CreateFieldWorkMutationVariables = Exact<{
  data: FieldWorkCreateInput;
}>;


export type CreateFieldWorkMutation = { __typename?: 'Mutation', createFieldWork?: { __typename?: 'FieldWork', id: string, siteAccessAndSafety?: string | null, initialSiteObservations?: unknown | null, preliminaryFireAssessment?: unknown | null } | null };

export type UpdateFieldWorkMutationVariables = Exact<{
  where: FieldWorkWhereUniqueInput;
  data: FieldWorkUpdateInput;
}>;


export type UpdateFieldWorkMutation = { __typename?: 'Mutation', updateFieldWork?: { __typename?: 'FieldWork', id: string, siteAccessAndSafety?: string | null, initialSiteObservations?: unknown | null, preliminaryFireAssessment?: unknown | null } | null };

export type UpdatePropertyInformationMutationVariables = Exact<{
  where: PropertyInformationWhereUniqueInput;
  data: PropertyInformationUpdateInput;
}>;


export type UpdatePropertyInformationMutation = { __typename?: 'Mutation', updatePropertyInformation?: { __typename?: 'PropertyInformation', id: string, riskAddress?: string | null, inspectionAddress?: string | null } | null };

export type UpdateReportReferenceMutationVariables = Exact<{
  where: ReportReferenceWhereUniqueInput;
  data: ReportReferenceUpdateInput;
}>;


export type UpdateReportReferenceMutation = { __typename?: 'Mutation', updateReportReference?: { __typename?: 'ReportReference', id: string, jobNumber?: string | null, claimNumber?: string | null, refNumber?: string | null } | null };

export type CreateReportReferenceMutationVariables = Exact<{
  data: ReportReferenceCreateInput;
}>;


export type CreateReportReferenceMutation = { __typename?: 'Mutation', createReportReference?: { __typename?: 'ReportReference', id: string, jobNumber?: string | null, claimNumber?: string | null, refNumber?: string | null } | null };

export type UploadReportPhotoMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type UploadReportPhotoMutation = { __typename?: 'Mutation', uploadReportPhoto: { __typename?: 'EvidencePhoto', id: string, url: string, filename: string, originalName: string } };

export type EndSessionMutationVariables = Exact<{ [key: string]: never; }>;


export type EndSessionMutation = { __typename?: 'Mutation', endSession: boolean };

export type UpdateReportSummaryMutationVariables = Exact<{
  where: ReportSummaryWhereUniqueInput;
  data: ReportSummaryUpdateInput;
}>;


export type UpdateReportSummaryMutation = { __typename?: 'Mutation', updateReportSummary?: { __typename?: 'ReportSummary', id: string, executiveSummary?: string | null, scope?: string | null, scopeItems?: unknown | null, keyConclusions?: string | null, recommendations?: string | null } | null };

export type CreateReportSummaryMutationVariables = Exact<{
  data: ReportSummaryCreateInput;
}>;


export type CreateReportSummaryMutation = { __typename?: 'Mutation', createReportSummary?: { __typename?: 'ReportSummary', id: string, executiveSummary?: string | null, scope?: string | null, scopeItems?: unknown | null, keyConclusions?: string | null, recommendations?: string | null } | null };

export type UpdateAnalysisMutationVariables = Exact<{
  where: AnalysisWhereUniqueInput;
  data: AnalysisUpdateInput;
}>;


export type UpdateAnalysisMutation = { __typename?: 'Mutation', updateAnalysis?: { __typename?: 'Analysis', id: string, circumstanceSummary?: string | null, observation?: unknown | null, narrative?: string | null, otherFactorsConsidered?: string | null } | null };

export type CreateAnalysisMutationVariables = Exact<{
  data: AnalysisCreateInput;
}>;


export type CreateAnalysisMutation = { __typename?: 'Mutation', createAnalysis?: { __typename?: 'Analysis', id: string, circumstanceSummary?: string | null, observation?: unknown | null, narrative?: string | null, otherFactorsConsidered?: string | null } | null };

export type UpdateSettingMutationVariables = Exact<{
  where: SettingWhereUniqueInput;
  data: SettingUpdateInput;
}>;


export type UpdateSettingMutation = { __typename?: 'Mutation', updateSetting?: { __typename?: 'Setting', id: string, defaultWeatherLeadInDays?: number | null } | null };

export type CreateWitnessInterviewMutationVariables = Exact<{
  data: WitnessInterviewCreateInput;
}>;


export type CreateWitnessInterviewMutation = { __typename?: 'Mutation', createWitnessInterview?: { __typename?: 'WitnessInterview', id: string, name?: string | null, witnessRelationship?: string | null, event?: string | null, interviewDatetime?: unknown | null, briefNote?: string | null, detailedNote?: string | null } | null };

export type UpdateWitnessInterviewMutationVariables = Exact<{
  where: WitnessInterviewWhereUniqueInput;
  data: WitnessInterviewUpdateInput;
}>;


export type UpdateWitnessInterviewMutation = { __typename?: 'Mutation', updateWitnessInterview?: { __typename?: 'WitnessInterview', id: string, name?: string | null, witnessRelationship?: string | null, event?: string | null, interviewDatetime?: unknown | null, briefNote?: string | null, detailedNote?: string | null } | null };

export type DeleteWitnessInterviewMutationVariables = Exact<{
  where: WitnessInterviewWhereUniqueInput;
}>;


export type DeleteWitnessInterviewMutation = { __typename?: 'Mutation', deleteWitnessInterview?: { __typename?: 'WitnessInterview', id: string } | null };

export type CreateReportReviewMutationVariables = Exact<{
  data: ReportReviewCreateInput;
}>;


export type CreateReportReviewMutation = { __typename?: 'Mutation', createReportReview?: { __typename?: 'ReportReview', id: string, clientInformation?: unknown | null, circumstancesSummary?: unknown | null, witnessStatements?: unknown | null, siteAccess?: unknown | null, weatherConditions?: unknown | null, executiveSummary?: unknown | null, scope?: unknown | null, keyConclusions?: unknown | null, recommendations?: unknown | null, otherFactorsConsidered?: unknown | null, overallComments?: string | null, status?: string | null, submittedAt?: unknown | null, reviewers?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> | null, notifiedReviewers?: Array<{ __typename?: 'User', id: string }> | null } | null };

export type UpdateReportReviewMutationVariables = Exact<{
  where: ReportReviewWhereUniqueInput;
  data: ReportReviewUpdateInput;
}>;


export type UpdateReportReviewMutation = { __typename?: 'Mutation', updateReportReview?: { __typename?: 'ReportReview', id: string, clientInformation?: unknown | null, circumstancesSummary?: unknown | null, witnessStatements?: unknown | null, siteAccess?: unknown | null, weatherConditions?: unknown | null, executiveSummary?: unknown | null, scope?: unknown | null, keyConclusions?: unknown | null, recommendations?: unknown | null, otherFactorsConsidered?: unknown | null, overallComments?: string | null, status?: string | null, submittedAt?: unknown | null, reviewers?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> | null, notifiedReviewers?: Array<{ __typename?: 'User', id: string }> | null } | null };

export type GenerateReportSummaryMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  field: SummaryField;
}>;


export type GenerateReportSummaryMutation = { __typename?: 'Mutation', generateReportSummary: { __typename?: 'GeneratedSummary', field: string, content: string } };

export type BuildReportConclusionsMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type BuildReportConclusionsMutation = { __typename?: 'Mutation', buildReportConclusions: { __typename?: 'GeneratedSummary', field: string, content: string } };

export type GenerateReportPdfMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  type: ReportPdfType;
}>;


export type GenerateReportPdfMutation = { __typename?: 'Mutation', generateReportPdf: { __typename?: 'GeneratedReportPdf', fileName: string, mimeType: string, base64: string } };

export type SendReportPdfMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  type: ReportPdfType;
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientEmails?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type SendReportPdfMutation = { __typename?: 'Mutation', sendReportPdf: { __typename?: 'SendReportPdfResult', success: boolean, recipientCount: number } };

export type GenerateAnalysisNarrativeMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
  observationData?: InputMaybe<Scalars['String']['input']>;
  circumstanceSummary?: InputMaybe<Scalars['String']['input']>;
  maxWords?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GenerateAnalysisNarrativeMutation = { __typename?: 'Mutation', generateAnalysisNarrative: { __typename?: 'GeneratedNarrative', content: string } };

export type MarkReportReadyForReviewMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type MarkReportReadyForReviewMutation = { __typename?: 'Mutation', markReportReadyForReview?: { __typename?: 'ReportReadyForReviewView', id: string, code?: string | null, client?: string | null, emailsFailed: number, notifiedReviewerIds: Array<string>, stage?: { __typename?: 'ReportStageRef', id: string, name?: string | null } | null } | null };

export type NotifyNewReviewersMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type NotifyNewReviewersMutation = { __typename?: 'Mutation', notifyNewReviewers: { __typename?: 'ReviewerNotification', emailsFailed: number, notifiedReviewerIds: Array<string> } };

export type MarkReportCompleteMutationVariables = Exact<{
  reportId: Scalars['ID']['input'];
}>;


export type MarkReportCompleteMutation = { __typename?: 'Mutation', markReportComplete?: { __typename?: 'ReportStageView', id: string, code?: string | null, client?: string | null, stage?: { __typename?: 'ReportStageRef', id: string, name?: string | null } | null } | null };

export type AddSettingOptionMutationVariables = Exact<{
  field: SettingOptionField;
  value: Scalars['String']['input'];
}>;


export type AddSettingOptionMutation = { __typename?: 'Mutation', addSettingOption: Array<{ __typename?: 'SettingOption', value: string, label: string }> };

export type GetAuthenticatedItemQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAuthenticatedItemQuery = { __typename?: 'Query', authenticatedItem?: { __typename?: 'User', id: string, email?: string | null, isAdmin?: boolean | null, mustChangePassword?: boolean | null, firstName?: string | null, lastName?: string | null, title?: string | null, credentials?: string | null, avatarUrl?: string | null } | null };

export type FindReportTypeByNameQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type FindReportTypeByNameQuery = { __typename?: 'Query', reportTypes?: Array<{ __typename?: 'ReportType', id: string }> | null };

export type GetSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSettingsQuery = { __typename?: 'Query', settings?: Array<{ __typename?: 'Setting', id: string, googleApiKey?: string | null, areaOfOriginOptions?: unknown | null, pointOfOriginOptions?: unknown | null, firstFuelOptions?: unknown | null, ignitionSourceOptions?: unknown | null, indicatorsOptions?: unknown | null, technicalTermsOptions?: unknown | null, attendeeOrganisationOptions?: unknown | null, attendeeRoleOptions?: unknown | null, witnessRelationshipOptions?: unknown | null, witnessEventOptions?: unknown | null, defaultSiteAccessText?: string | null, initialSiteObservationOptions?: unknown | null, preliminaryFireAssessmentOptions?: unknown | null, evidenceCategoryOptions?: unknown | null, insurerOptions?: unknown | null, brokerOptions?: unknown | null, defaultWeatherLeadInDays?: number | null }> | null };

export type ReportListFieldsFragment = { __typename?: 'Report', id: string, code?: string | null, client?: string | null, dateOfLoss?: unknown | null, dateOfInspection?: unknown | null, insurer?: string | null, broker?: string | null, created_at?: unknown | null, reportType?: { __typename?: 'ReportType', name?: string | null } | null, stage?: { __typename?: 'ReportStage', name?: string | null } | null, status?: { __typename?: 'ReportStatus', name?: string | null } | null, propertyInformation?: { __typename?: 'PropertyInformation', riskAddress?: string | null, latitude?: number | null, longitude?: number | null } | null, assessor?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, reviews?: Array<{ __typename?: 'ReportReview', reviewers?: Array<{ __typename?: 'User', firstName?: string | null, lastName?: string | null }> | null }> | null };

export type GetAllReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllReportsQuery = { __typename?: 'Query', reports?: Array<{ __typename?: 'Report', id: string, code?: string | null, client?: string | null, dateOfLoss?: unknown | null, dateOfInspection?: unknown | null, insurer?: string | null, broker?: string | null, created_at?: unknown | null, reportType?: { __typename?: 'ReportType', name?: string | null } | null, stage?: { __typename?: 'ReportStage', name?: string | null } | null, status?: { __typename?: 'ReportStatus', name?: string | null } | null, propertyInformation?: { __typename?: 'PropertyInformation', riskAddress?: string | null, latitude?: number | null, longitude?: number | null } | null, assessor?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, reviews?: Array<{ __typename?: 'ReportReview', reviewers?: Array<{ __typename?: 'User', firstName?: string | null, lastName?: string | null }> | null }> | null }> | null };

export type GetAllReportsPaginatedQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetAllReportsPaginatedQuery = { __typename?: 'Query', reportsCount?: number | null, reports?: Array<{ __typename?: 'Report', id: string, code?: string | null, client?: string | null, dateOfLoss?: unknown | null, dateOfInspection?: unknown | null, insurer?: string | null, broker?: string | null, created_at?: unknown | null, reportType?: { __typename?: 'ReportType', name?: string | null } | null, stage?: { __typename?: 'ReportStage', name?: string | null } | null, status?: { __typename?: 'ReportStatus', name?: string | null } | null, propertyInformation?: { __typename?: 'PropertyInformation', riskAddress?: string | null, latitude?: number | null, longitude?: number | null } | null, assessor?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, reviews?: Array<{ __typename?: 'ReportReview', reviewers?: Array<{ __typename?: 'User', firstName?: string | null, lastName?: string | null }> | null }> | null }> | null };

export type ReportReviewFieldsFragment = { __typename?: 'ReportReview', id: string, clientInformation?: unknown | null, circumstancesSummary?: unknown | null, witnessStatements?: unknown | null, siteAccess?: unknown | null, weatherConditions?: unknown | null, executiveSummary?: unknown | null, scope?: unknown | null, keyConclusions?: unknown | null, recommendations?: unknown | null, otherFactorsConsidered?: unknown | null, overallComments?: string | null, status?: string | null, submittedAt?: unknown | null, reviewers?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> | null, notifiedReviewers?: Array<{ __typename?: 'User', id: string }> | null };

export type GetReportByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetReportByIdQuery = { __typename?: 'Query', report?: { __typename?: 'Report', id: string, code?: string | null, client?: string | null, insurer?: string | null, broker?: string | null, asset?: string | null, dateOfLoss?: unknown | null, dateOfInspection?: unknown | null, evidence?: unknown | null, weatherCondition?: unknown | null, weatherLeadInDays?: number | null, created_at?: unknown | null, attendees?: unknown | null, reportType?: { __typename?: 'ReportType', id: string, name?: string | null } | null, stage?: { __typename?: 'ReportStage', id: string, name?: string | null } | null, status?: { __typename?: 'ReportStatus', id: string, name?: string | null } | null, assessor?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null } | null, propertyInformation?: { __typename?: 'PropertyInformation', id: string, riskAddress?: string | null, inspectionAddress?: string | null } | null, references?: Array<{ __typename?: 'ReportReference', id: string, claimNumber?: string | null, jobNumber?: string | null, refNumber?: string | null }> | null, witnessInterviews?: Array<{ __typename?: 'WitnessInterview', id: string, name?: string | null, witnessRelationship?: string | null, event?: string | null, interviewDatetime?: unknown | null, briefNote?: string | null, detailedNote?: string | null }> | null, reviews?: Array<{ __typename?: 'ReportReview', id: string, clientInformation?: unknown | null, circumstancesSummary?: unknown | null, witnessStatements?: unknown | null, siteAccess?: unknown | null, weatherConditions?: unknown | null, executiveSummary?: unknown | null, scope?: unknown | null, keyConclusions?: unknown | null, recommendations?: unknown | null, otherFactorsConsidered?: unknown | null, overallComments?: string | null, status?: string | null, submittedAt?: unknown | null, reviewers?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null }> | null, notifiedReviewers?: Array<{ __typename?: 'User', id: string }> | null }> | null, summary?: { __typename?: 'ReportSummary', id: string, executiveSummary?: string | null, scope?: string | null, scopeItems?: unknown | null, keyConclusions?: string | null, recommendations?: string | null } | null, analysis?: { __typename?: 'Analysis', id: string, circumstanceSummary?: string | null, observation?: unknown | null, narrative?: string | null, otherFactorsConsidered?: string | null } | null, fieldWork?: { __typename?: 'FieldWork', id: string, siteAccessAndSafety?: string | null, initialSiteObservations?: unknown | null, preliminaryFireAssessment?: unknown | null } | null } | null };

export type GetAllReportStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllReportStatusesQuery = { __typename?: 'Query', reportStatuses?: Array<{ __typename?: 'ReportStatus', id: string, name?: string | null }> | null };

export type GetAllReportStagesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllReportStagesQuery = { __typename?: 'Query', reportStages?: Array<{ __typename?: 'ReportStage', id: string, name?: string | null }> | null };

export type GetAllUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUsersQuery = { __typename?: 'Query', users?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null, email?: string | null, title?: string | null }> | null };

export type GetAllReportTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllReportTypesQuery = { __typename?: 'Query', reportTypes?: Array<{ __typename?: 'ReportType', id: string, name?: string | null }> | null };

export type SearchReportsQueryVariables = Exact<{
  where: ReportWhereInput;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchReportsQuery = { __typename?: 'Query', reportsCount?: number | null, reports?: Array<{ __typename?: 'Report', id: string, code?: string | null, client?: string | null, dateOfLoss?: unknown | null, dateOfInspection?: unknown | null, insurer?: string | null, broker?: string | null, created_at?: unknown | null, reportType?: { __typename?: 'ReportType', name?: string | null } | null, stage?: { __typename?: 'ReportStage', name?: string | null } | null, status?: { __typename?: 'ReportStatus', name?: string | null } | null, propertyInformation?: { __typename?: 'PropertyInformation', riskAddress?: string | null } | null, assessor?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null, reviews?: Array<{ __typename?: 'ReportReview', reviewers?: Array<{ __typename?: 'User', firstName?: string | null, lastName?: string | null }> | null }> | null }> | null };

export type GetDashboardStatsQueryVariables = Exact<{
  completedMonthStart: Scalars['DateTime']['input'];
}>;


export type GetDashboardStatsQuery = { __typename?: 'Query', activeCount?: number | null, completedThisMonthCount?: number | null, pendingReviewCount?: number | null, completedReports?: Array<{ __typename?: 'Report', id: string, created_at?: unknown | null, completedAt?: unknown | null }> | null, recentReports?: Array<{ __typename?: 'Report', id: string, code?: string | null, client?: string | null, created_at?: unknown | null, status?: { __typename?: 'ReportStatus', name?: string | null } | null, stage?: { __typename?: 'ReportStage', name?: string | null } | null }> | null };

export type GetActiveReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveReportsQuery = { __typename?: 'Query', reports?: Array<{ __typename?: 'Report', id: string, code?: string | null, client?: string | null, dateOfLoss?: unknown | null, dateOfInspection?: unknown | null, insurer?: string | null, broker?: string | null, created_at?: unknown | null, reportType?: { __typename?: 'ReportType', name?: string | null } | null, stage?: { __typename?: 'ReportStage', name?: string | null } | null, status?: { __typename?: 'ReportStatus', name?: string | null } | null, propertyInformation?: { __typename?: 'PropertyInformation', riskAddress?: string | null } | null, assessor?: { __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null } | null, reviews?: Array<{ __typename?: 'ReportReview', reviewers?: Array<{ __typename?: 'User', id: string, firstName?: string | null, lastName?: string | null }> | null }> | null }> | null };

export const ReportListFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"propertyInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAddress"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLoss"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfInspection"}},{"kind":"Field","name":{"kind":"Name","value":"insurer"}},{"kind":"Field","name":{"kind":"Name","value":"broker"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]} as unknown as DocumentNode<ReportListFieldsFragment, unknown>;
export const ReportReviewFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportReviewFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientInformation"}},{"kind":"Field","name":{"kind":"Name","value":"circumstancesSummary"}},{"kind":"Field","name":{"kind":"Name","value":"witnessStatements"}},{"kind":"Field","name":{"kind":"Name","value":"siteAccess"}},{"kind":"Field","name":{"kind":"Name","value":"weatherConditions"}},{"kind":"Field","name":{"kind":"Name","value":"executiveSummary"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"keyConclusions"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"}},{"kind":"Field","name":{"kind":"Name","value":"otherFactorsConsidered"}},{"kind":"Field","name":{"kind":"Name","value":"overallComments"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifiedReviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ReportReviewFieldsFragment, unknown>;
export const GetPlaceholdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaceholders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetPlaceholdersQuery, GetPlaceholdersQueryVariables>;
export const GetPlaceholderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPlaceholder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeholder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetPlaceholderQuery, GetPlaceholderQueryVariables>;
export const CreatePlaceholderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePlaceholder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlaceholderCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlaceholder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CreatePlaceholderMutation, CreatePlaceholderMutationVariables>;
export const UpdatePlaceholderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePlaceholder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlaceholderWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlaceholderUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePlaceholder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<UpdatePlaceholderMutation, UpdatePlaceholderMutationVariables>;
export const DeletePlaceholderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePlaceholder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PlaceholderWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePlaceholder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeletePlaceholderMutation, DeletePlaceholderMutationVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticateUserWithPassword"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserAuthenticationWithPasswordFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UserAuthenticationWithPasswordSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sessionToken"}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const UpdateUserPasswordDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserPassword"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<UpdateUserPasswordMutation, UpdateUserPasswordMutationVariables>;
export const UpdateUserInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUserInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]} as unknown as DocumentNode<UpdateUserInformationMutation, UpdateUserInformationMutationVariables>;
export const SendMagicLinkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendMagicLink"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendUserMagicAuthLink"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<SendMagicLinkMutation, SendMagicLinkMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const VerifyMagicTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VerifyMagicToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"redeemUserMagicAuthToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}},{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RedeemUserMagicAuthTokenFailure"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"message"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RedeemUserMagicAuthTokenSuccess"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]}}]} as unknown as DocumentNode<VerifyMagicTokenMutation, VerifyMagicTokenMutationVariables>;
export const CreateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}}]}}]}}]} as unknown as DocumentNode<CreateReportMutation, CreateReportMutationVariables>;
export const UpdateReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"insurer"}},{"kind":"Field","name":{"kind":"Name","value":"broker"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"weatherCondition"}},{"kind":"Field","name":{"kind":"Name","value":"weatherLeadInDays"}},{"kind":"Field","name":{"kind":"Name","value":"evidence"}},{"kind":"Field","name":{"kind":"Name","value":"attendees"}}]}}]}}]} as unknown as DocumentNode<UpdateReportMutation, UpdateReportMutationVariables>;
export const CreateFieldWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateFieldWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldWorkCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createFieldWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteAccessAndSafety"}},{"kind":"Field","name":{"kind":"Name","value":"initialSiteObservations"}},{"kind":"Field","name":{"kind":"Name","value":"preliminaryFireAssessment"}}]}}]}}]} as unknown as DocumentNode<CreateFieldWorkMutation, CreateFieldWorkMutationVariables>;
export const UpdateFieldWorkDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateFieldWork"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldWorkWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FieldWorkUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateFieldWork"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteAccessAndSafety"}},{"kind":"Field","name":{"kind":"Name","value":"initialSiteObservations"}},{"kind":"Field","name":{"kind":"Name","value":"preliminaryFireAssessment"}}]}}]}}]} as unknown as DocumentNode<UpdateFieldWorkMutation, UpdateFieldWorkMutationVariables>;
export const UpdatePropertyInformationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePropertyInformation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyInformationWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PropertyInformationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePropertyInformation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"riskAddress"}},{"kind":"Field","name":{"kind":"Name","value":"inspectionAddress"}}]}}]}}]} as unknown as DocumentNode<UpdatePropertyInformationMutation, UpdatePropertyInformationMutationVariables>;
export const UpdateReportReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReportReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReferenceWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReferenceUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReportReference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobNumber"}},{"kind":"Field","name":{"kind":"Name","value":"claimNumber"}},{"kind":"Field","name":{"kind":"Name","value":"refNumber"}}]}}]}}]} as unknown as DocumentNode<UpdateReportReferenceMutation, UpdateReportReferenceMutationVariables>;
export const CreateReportReferenceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReportReference"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReferenceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReportReference"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"jobNumber"}},{"kind":"Field","name":{"kind":"Name","value":"claimNumber"}},{"kind":"Field","name":{"kind":"Name","value":"refNumber"}}]}}]}}]} as unknown as DocumentNode<CreateReportReferenceMutation, CreateReportReferenceMutationVariables>;
export const UploadReportPhotoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadReportPhoto"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadReportPhoto"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}},{"kind":"Field","name":{"kind":"Name","value":"originalName"}}]}}]}}]} as unknown as DocumentNode<UploadReportPhotoMutation, UploadReportPhotoMutationVariables>;
export const EndSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EndSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endSession"}}]}}]} as unknown as DocumentNode<EndSessionMutation, EndSessionMutationVariables>;
export const UpdateReportSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReportSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportSummaryWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportSummaryUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReportSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"executiveSummary"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"scopeItems"}},{"kind":"Field","name":{"kind":"Name","value":"keyConclusions"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"}}]}}]}}]} as unknown as DocumentNode<UpdateReportSummaryMutation, UpdateReportSummaryMutationVariables>;
export const CreateReportSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReportSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportSummaryCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReportSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"executiveSummary"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"scopeItems"}},{"kind":"Field","name":{"kind":"Name","value":"keyConclusions"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"}}]}}]}}]} as unknown as DocumentNode<CreateReportSummaryMutation, CreateReportSummaryMutationVariables>;
export const UpdateAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalysisWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalysisUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"circumstanceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"observation"}},{"kind":"Field","name":{"kind":"Name","value":"narrative"}},{"kind":"Field","name":{"kind":"Name","value":"otherFactorsConsidered"}}]}}]}}]} as unknown as DocumentNode<UpdateAnalysisMutation, UpdateAnalysisMutationVariables>;
export const CreateAnalysisDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAnalysis"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AnalysisCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAnalysis"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"circumstanceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"observation"}},{"kind":"Field","name":{"kind":"Name","value":"narrative"}},{"kind":"Field","name":{"kind":"Name","value":"otherFactorsConsidered"}}]}}]}}]} as unknown as DocumentNode<CreateAnalysisMutation, CreateAnalysisMutationVariables>;
export const UpdateSettingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateSetting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SettingWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SettingUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateSetting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"defaultWeatherLeadInDays"}}]}}]}}]} as unknown as DocumentNode<UpdateSettingMutation, UpdateSettingMutationVariables>;
export const CreateWitnessInterviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateWitnessInterview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WitnessInterviewCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createWitnessInterview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"witnessRelationship"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"interviewDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"briefNote"}},{"kind":"Field","name":{"kind":"Name","value":"detailedNote"}}]}}]}}]} as unknown as DocumentNode<CreateWitnessInterviewMutation, CreateWitnessInterviewMutationVariables>;
export const UpdateWitnessInterviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateWitnessInterview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WitnessInterviewWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WitnessInterviewUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateWitnessInterview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"witnessRelationship"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"interviewDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"briefNote"}},{"kind":"Field","name":{"kind":"Name","value":"detailedNote"}}]}}]}}]} as unknown as DocumentNode<UpdateWitnessInterviewMutation, UpdateWitnessInterviewMutationVariables>;
export const DeleteWitnessInterviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteWitnessInterview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"WitnessInterviewWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteWitnessInterview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteWitnessInterviewMutation, DeleteWitnessInterviewMutationVariables>;
export const CreateReportReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateReportReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReviewCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createReportReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportReviewFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportReviewFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientInformation"}},{"kind":"Field","name":{"kind":"Name","value":"circumstancesSummary"}},{"kind":"Field","name":{"kind":"Name","value":"witnessStatements"}},{"kind":"Field","name":{"kind":"Name","value":"siteAccess"}},{"kind":"Field","name":{"kind":"Name","value":"weatherConditions"}},{"kind":"Field","name":{"kind":"Name","value":"executiveSummary"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"keyConclusions"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"}},{"kind":"Field","name":{"kind":"Name","value":"otherFactorsConsidered"}},{"kind":"Field","name":{"kind":"Name","value":"overallComments"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifiedReviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CreateReportReviewMutation, CreateReportReviewMutationVariables>;
export const UpdateReportReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateReportReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReviewWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReviewUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateReportReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportReviewFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportReviewFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientInformation"}},{"kind":"Field","name":{"kind":"Name","value":"circumstancesSummary"}},{"kind":"Field","name":{"kind":"Name","value":"witnessStatements"}},{"kind":"Field","name":{"kind":"Name","value":"siteAccess"}},{"kind":"Field","name":{"kind":"Name","value":"weatherConditions"}},{"kind":"Field","name":{"kind":"Name","value":"executiveSummary"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"keyConclusions"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"}},{"kind":"Field","name":{"kind":"Name","value":"otherFactorsConsidered"}},{"kind":"Field","name":{"kind":"Name","value":"overallComments"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifiedReviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<UpdateReportReviewMutation, UpdateReportReviewMutationVariables>;
export const GenerateReportSummaryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateReportSummary"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"field"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SummaryField"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateReportSummary"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"field"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<GenerateReportSummaryMutation, GenerateReportSummaryMutationVariables>;
export const BuildReportConclusionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"BuildReportConclusions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"buildReportConclusions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"}},{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<BuildReportConclusionsMutation, BuildReportConclusionsMutationVariables>;
export const GenerateReportPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateReportPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportPdfType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateReportPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileName"}},{"kind":"Field","name":{"kind":"Name","value":"mimeType"}},{"kind":"Field","name":{"kind":"Name","value":"base64"}}]}}]}}]} as unknown as DocumentNode<GenerateReportPdfMutation, GenerateReportPdfMutationVariables>;
export const SendReportPdfDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendReportPdf"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportPdfType"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"clientEmail"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"recipientEmails"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendReportPdf"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"clientEmail"},"value":{"kind":"Variable","name":{"kind":"Name","value":"clientEmail"}}},{"kind":"Argument","name":{"kind":"Name","value":"recipientEmails"},"value":{"kind":"Variable","name":{"kind":"Name","value":"recipientEmails"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"recipientCount"}}]}}]}}]} as unknown as DocumentNode<SendReportPdfMutation, SendReportPdfMutationVariables>;
export const GenerateAnalysisNarrativeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateAnalysisNarrative"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"observationData"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"circumstanceSummary"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxWords"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateAnalysisNarrative"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}},{"kind":"Argument","name":{"kind":"Name","value":"observationData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"observationData"}}},{"kind":"Argument","name":{"kind":"Name","value":"circumstanceSummary"},"value":{"kind":"Variable","name":{"kind":"Name","value":"circumstanceSummary"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxWords"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxWords"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"content"}}]}}]}}]} as unknown as DocumentNode<GenerateAnalysisNarrativeMutation, GenerateAnalysisNarrativeMutationVariables>;
export const MarkReportReadyForReviewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkReportReadyForReview"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markReportReadyForReview"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"emailsFailed"}},{"kind":"Field","name":{"kind":"Name","value":"notifiedReviewerIds"}}]}}]}}]} as unknown as DocumentNode<MarkReportReadyForReviewMutation, MarkReportReadyForReviewMutationVariables>;
export const NotifyNewReviewersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NotifyNewReviewers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifyNewReviewers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"emailsFailed"}},{"kind":"Field","name":{"kind":"Name","value":"notifiedReviewerIds"}}]}}]}}]} as unknown as DocumentNode<NotifyNewReviewersMutation, NotifyNewReviewersMutationVariables>;
export const MarkReportCompleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"MarkReportComplete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"markReportComplete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"reportId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"reportId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<MarkReportCompleteMutation, MarkReportCompleteMutationVariables>;
export const AddSettingOptionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddSettingOption"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"field"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SettingOptionField"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"value"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addSettingOption"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"field"},"value":{"kind":"Variable","name":{"kind":"Name","value":"field"}}},{"kind":"Argument","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"value"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]}}]} as unknown as DocumentNode<AddSettingOptionMutation, AddSettingOptionMutationVariables>;
export const GetAuthenticatedItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAuthenticatedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authenticatedItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"isAdmin"}},{"kind":"Field","name":{"kind":"Name","value":"mustChangePassword"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"}},{"kind":"Field","name":{"kind":"Name","value":"avatarUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetAuthenticatedItemQuery, GetAuthenticatedItemQueryVariables>;
export const FindReportTypeByNameDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FindReportTypeByName"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FindReportTypeByNameQuery, FindReportTypeByNameQueryVariables>;
export const GetSettingsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetSettings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"googleApiKey"}},{"kind":"Field","name":{"kind":"Name","value":"areaOfOriginOptions"}},{"kind":"Field","name":{"kind":"Name","value":"pointOfOriginOptions"}},{"kind":"Field","name":{"kind":"Name","value":"firstFuelOptions"}},{"kind":"Field","name":{"kind":"Name","value":"ignitionSourceOptions"}},{"kind":"Field","name":{"kind":"Name","value":"indicatorsOptions"}},{"kind":"Field","name":{"kind":"Name","value":"technicalTermsOptions"}},{"kind":"Field","name":{"kind":"Name","value":"attendeeOrganisationOptions"}},{"kind":"Field","name":{"kind":"Name","value":"attendeeRoleOptions"}},{"kind":"Field","name":{"kind":"Name","value":"witnessRelationshipOptions"}},{"kind":"Field","name":{"kind":"Name","value":"witnessEventOptions"}},{"kind":"Field","name":{"kind":"Name","value":"defaultSiteAccessText"}},{"kind":"Field","name":{"kind":"Name","value":"initialSiteObservationOptions"}},{"kind":"Field","name":{"kind":"Name","value":"preliminaryFireAssessmentOptions"}},{"kind":"Field","name":{"kind":"Name","value":"evidenceCategoryOptions"}},{"kind":"Field","name":{"kind":"Name","value":"insurerOptions"}},{"kind":"Field","name":{"kind":"Name","value":"brokerOptions"}},{"kind":"Field","name":{"kind":"Name","value":"defaultWeatherLeadInDays"}}]}}]}}]} as unknown as DocumentNode<GetSettingsQuery, GetSettingsQueryVariables>;
export const GetAllReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportListFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"propertyInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAddress"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLoss"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfInspection"}},{"kind":"Field","name":{"kind":"Name","value":"insurer"}},{"kind":"Field","name":{"kind":"Name","value":"broker"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]} as unknown as DocumentNode<GetAllReportsQuery, GetAllReportsQueryVariables>;
export const GetAllReportsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllReportsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportListFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsCount"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportListFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Report"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"propertyInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAddress"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLoss"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfInspection"}},{"kind":"Field","name":{"kind":"Name","value":"insurer"}},{"kind":"Field","name":{"kind":"Name","value":"broker"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]} as unknown as DocumentNode<GetAllReportsPaginatedQuery, GetAllReportsPaginatedQueryVariables>;
export const GetReportByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReportById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"report"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"insurer"}},{"kind":"Field","name":{"kind":"Name","value":"broker"}},{"kind":"Field","name":{"kind":"Name","value":"asset"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLoss"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfInspection"}},{"kind":"Field","name":{"kind":"Name","value":"evidence"}},{"kind":"Field","name":{"kind":"Name","value":"weatherCondition"}},{"kind":"Field","name":{"kind":"Name","value":"weatherLeadInDays"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"propertyInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"riskAddress"}},{"kind":"Field","name":{"kind":"Name","value":"inspectionAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"references"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"claimNumber"}},{"kind":"Field","name":{"kind":"Name","value":"jobNumber"}},{"kind":"Field","name":{"kind":"Name","value":"refNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"witnessInterviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"witnessRelationship"}},{"kind":"Field","name":{"kind":"Name","value":"event"}},{"kind":"Field","name":{"kind":"Name","value":"interviewDatetime"}},{"kind":"Field","name":{"kind":"Name","value":"briefNote"}},{"kind":"Field","name":{"kind":"Name","value":"detailedNote"}}]}},{"kind":"Field","name":{"kind":"Name","value":"attendees"}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ReportReviewFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"summary"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"executiveSummary"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"scopeItems"}},{"kind":"Field","name":{"kind":"Name","value":"keyConclusions"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"}}]}},{"kind":"Field","name":{"kind":"Name","value":"analysis"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"circumstanceSummary"}},{"kind":"Field","name":{"kind":"Name","value":"observation"}},{"kind":"Field","name":{"kind":"Name","value":"narrative"}},{"kind":"Field","name":{"kind":"Name","value":"otherFactorsConsidered"}}]}},{"kind":"Field","name":{"kind":"Name","value":"fieldWork"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"siteAccessAndSafety"}},{"kind":"Field","name":{"kind":"Name","value":"initialSiteObservations"}},{"kind":"Field","name":{"kind":"Name","value":"preliminaryFireAssessment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ReportReviewFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportReview"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"clientInformation"}},{"kind":"Field","name":{"kind":"Name","value":"circumstancesSummary"}},{"kind":"Field","name":{"kind":"Name","value":"witnessStatements"}},{"kind":"Field","name":{"kind":"Name","value":"siteAccess"}},{"kind":"Field","name":{"kind":"Name","value":"weatherConditions"}},{"kind":"Field","name":{"kind":"Name","value":"executiveSummary"}},{"kind":"Field","name":{"kind":"Name","value":"scope"}},{"kind":"Field","name":{"kind":"Name","value":"keyConclusions"}},{"kind":"Field","name":{"kind":"Name","value":"recommendations"}},{"kind":"Field","name":{"kind":"Name","value":"otherFactorsConsidered"}},{"kind":"Field","name":{"kind":"Name","value":"overallComments"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"submittedAt"}},{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"notifiedReviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<GetReportByIdQuery, GetReportByIdQueryVariables>;
export const GetAllReportStatusesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllReportStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportStatuses"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAllReportStatusesQuery, GetAllReportStatusesQueryVariables>;
export const GetAllReportStagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllReportStages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportStages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAllReportStagesQuery, GetAllReportStagesQueryVariables>;
export const GetAllUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<GetAllUsersQuery, GetAllUsersQueryVariables>;
export const GetAllReportTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAllReportTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAllReportTypesQuery, GetAllReportTypesQueryVariables>;
export const SearchReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchReports"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ReportWhereInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"propertyInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLoss"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfInspection"}},{"kind":"Field","name":{"kind":"Name","value":"insurer"}},{"kind":"Field","name":{"kind":"Name","value":"broker"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}]}]}}]} as unknown as DocumentNode<SearchReportsQuery, SearchReportsQueryVariables>;
export const GetDashboardStatsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardStats"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"completedMonthStart"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DateTime"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"activeCount"},"name":{"kind":"Name","value":"reportsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"Active","block":false}}]}}]}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"completedThisMonthCount"},"name":{"kind":"Name","value":"reportsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"Completed","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"gte"},"value":{"kind":"Variable","name":{"kind":"Name","value":"completedMonthStart"}}}]}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"pendingReviewCount"},"name":{"kind":"Name","value":"reportsCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"Active","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"stage"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"Under Review","block":false}}]}}]}}]}}]},{"kind":"Field","alias":{"kind":"Name","value":"completedReports"},"name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"Completed","block":false}}]}}]}},{"kind":"ObjectField","name":{"kind":"Name","value":"completedAt"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"not"},"value":{"kind":"NullValue"}}]}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"recentReports"},"name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"IntValue","value":"5"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardStatsQuery, GetDashboardStatsQueryVariables>;
export const GetActiveReportsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetActiveReports"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reports"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"status"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"equals"},"value":{"kind":"StringValue","value":"Active","block":false}}]}}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"created_at"},"value":{"kind":"EnumValue","value":"desc"}}]}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"client"}},{"kind":"Field","name":{"kind":"Name","value":"reportType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"stage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"propertyInformation"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"riskAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"assessor"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"reviews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reviewers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateOfLoss"}},{"kind":"Field","name":{"kind":"Name","value":"dateOfInspection"}},{"kind":"Field","name":{"kind":"Name","value":"insurer"}},{"kind":"Field","name":{"kind":"Name","value":"broker"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}}]}}]}}]} as unknown as DocumentNode<GetActiveReportsQuery, GetActiveReportsQueryVariables>;